/* eslint-disable */
const messages = {
  V: `v`,
  TEAM_ID: `ID: {id}`,
  TEAM_NAME: `Team: {name}`,
  DASHBOARD: `Dashboard`,
  INDICATOR: `Indicator`,
  INDICATORS: `Indicators`,
  THEME: `Theme`,
  ACTION_PLANS: `Action plans`,
  PENDING: `Pending actions`,
  PROBLEMS: `Problems`,
  PROBLEMS_SHORT: `Prob.`,
  PROBLEM_SOLVING: `Problem solving`,
  DMP: `Daily management of performance`,
  SYNTHESIS: `Synthesis meeting`,
  STATS: `Stats`,
  INFORMATION: `Information`,
  INFORMATIONS: `Information`,
  INFORMATIONS_SHORT: `Info`,
  FILTERS: `Filters`,
  ARCHIVES: `Archives`,
  SCHEDULE: `Schedule`,
  OPTIONS: `Options`,
  PROBLEM: `Problem`,
  NEW_PROBLEM: `New problem`,
  ADD_PROBLEM: `Add a problem`,
  ADD_ACTION: `Add an action`,
  SEARCH: `Search`,
  SEARCH_PH: `@:(message.SEARCH)…`,
  CAUSES: `Causes`,
  CAUSE: `Cause`,
  CAUSE_DESCRIPTION: `Cause description`,
  ACTION: `Action`,
  ACTIONS: `Actions`,
  ACTION_NAME: `Action name`,
  MEETINGS: `Meetings`,
  MEETINGS_SHORT: `Meet.`,
  LANGUAGE: `Language`,
  SUMMARY: `Summary`,
  CLOSE: `Close`,
  SUBMIT: `Submit`,
  SORT: `Sort`,
  TWO_DOTS: `: `,
  HYPHEN: `-`,
  LOGIN: `Login`,
  SECURE_AUTHENTICATION: `Secure authentication`,
  CANCEL: `Cancel`,
  DELETE: `Delete`,
  RESTORE: `Restore`,
  IGNORE: `Ignore`,
  TAGS: `Tags`,
  TO_BE_DEFINED: `To be defined`,
  SELECT_COLOR: `Select a color`,
  NONE: `None`,
  NONE_FEM: `None`,
  OK: `Ok`,
  GW_OK: `OK`,
  GW_NOK: `NOK`,
  YES: `Yes`,
  NO: `No`,
  REALLY_BAD: `Really bad`,
  BAD: `Bad`,
  NOT_SO_GOOD: `Not so good`,
  OKAY: `Okay`,
  GOOD: `Good`,
  EXCELLENT: `Excellent`,
  DUPLICATE: `Duplicate`,
  SEND: `Send`,
  SELECT: `Select`,
  NOT_APPLICABLE_SHORT: `N/A`,
  NOT_APPLICABLE_PARENTHESIS: `(Not Applicable)`,
  TEXT_COMMA: ` ,`,
  AND: `and`,
  QUOTE: `'`,
  START: `Start`,
  SEE_MORE: `See more`,
  LOAD_MORE: `Load more…`,
  EXAMPLE: `Example`,
  PIXELS: `Pixels`,
  CHART: `Chart`,
  TABLE: `Table`,
  CLICK_TOOLTIP_TO_ENLARGE: `Click to enlarge`,
  DECIMAL_POINT: `.`,
  MANUAL_INPUT: `Manual input`,
  INDICATOR_OF_MY_TEAM: `Indicator of my team`,
  INDICATOR_OF_OTHER_TEAM: `Indicator of another team`,
  N_MISSING_VALUES: `No missing values | 1 missing value | {nb} missing values`,
  BETA_TAG: `BETA`,
  CONTENT_BETWEEN_PARENTHESES: `({content})`,
  LOGIN_BY_TEAM: `Via team account`,
  LOGIN_BY_USER: `Via user account`,
  LOGIN_BY_SSO: `Via Single Sign-On`,
  LOGIN_BY_TEAM_SHORT: `@:message.TEAM`,
  LOGIN_BY_USER_SHORT: `@:message.USER`,
  LOGIN_BY_SSO_SHORT: `Single Sign-On`,
  LOGIN_BY_SSO_HINT: `Enter your team identifier if you wan to log in to the team account OR your username if you want to log in to your personnal account.`,
  LOGIN_TEAM_ID: `Team identifier`,
  LOGIN_TEAM_ID_EXAMPLE: `Team identifier (e.g. '123456')`,
  LOGIN_USER_ID: `Username`,
  LOGIN_USER_ID_EXAMPLE: `Username (e.g. 'j.doe')`,
  LOGIN_PWD: `Password`,
  LOGIN__COMPANY_PWD: `Company password`,
  LOGIN_SUBMIT: `Sign in`,
  STAY_CONNECTED: `Stay connected`,
  FORGOT_PASSWORD: `Forgot your password ?`,
  NEED_NEW_PWD: `Do you want to receive a new password via the email address of your team ?<br/>The password will change for the entire team.<br/>If there's no valid email address configured for this team, the email will be sent to info@shizen.io.<br/><br/>Any connected user will remain connected.`,
  NEED_NEW_PWD_USER: `Would you like to receive a new user password ?<br/>If there's no valid email address configured for your account, the email will be sent to your team's email address.<br>If it is not configured, it will be sent to info@shizen.io.`,
  NEW_PWD_TEAM_ID: `ID : (6 or 7 digit)-(3 letters) without brackets`,
  NEW_PWD_USER_ID: `Enter your username`,
  PWD_RESET_SUCCESS: `Your password has been reset. Please find your new password in the email we sent.`,
  NEW_PWD_WRONG_FORMAT: `It seems that your team ID doesn't match the required format : The ID is composed of 6 or 7 digits followed bya dash '-' and then 3 alphanumeric characters.<br/>Example : 100753-H7D`,
  NEW_PWD_NO_MATCH: `It seems that the ID you entered doesn't match any Shizen team. Please check again.`,
  SEARCH_PLACEHOLDER: `Search...`,
  TYPE_IN_SEARCH_FIELD: `Type a few characters in the search field`,
  SEARCHING_DOTS: `Searching...`,
  NO_MATCH_PROBLEMS: `No problems matching your search`,
  NO_MATCH_ACTIONS: `No actions matching your search`,
  NO_MATCH_GW: `No field tours matching your search`,
  NO_MATCH_TEAMS: `No teams matching your search`,
  SETTINGS: `Settings`,
  SETTINGS_SAML: `SAML authentication settings (SSO)`,
  SETTINGS_MAIN: `Main settings`,
  SETTINGS_INDICATORS: `Indicators`,
  SETTINGS_ACTIONS: `Actions`,
  SETTINGS_PROBLEMS: `Problems`,
  SETTINGS_INDICATORS_THEMES: `Indicators and themes`,
  SETTINGS_DASHBOARD: `Dashboard`,
  SETTINGS_MEETINGS: `Meetings`,
  SETTINGS_TEAM: `Team details`,
  SETTINGS_GW: `@:message.GEMBA_WALKS`,
  SETTINGS_PAGES: `Settings pages`,
  ADD_TYPE: `Add a type`,
  DELETE_SUBTYPES: `Would you like to delete the sub-types too ?`,
  CUSTOM_PROBLEM_HINTS: `Customize problem fields hints`,
  CUSTOM_PROBLEM_HINTS_EXPLANATION: `You may customize the content of the hint displayed below a field when reporting a problem.<br>You might also choose to display these hints in the problem sheet.`,
  DISPLAY_PROBLEM_HINT_SHEET: `Display in the problem sheet`,
  USE_COMPANY_SETTING: `Use company setting`,
  DEFAULT_HINTS: `Default hints`,
  CUSTOM_PROBLEM_HINTS_HOWTO: `Fill the fields below with the content that needs to be displayed below each field when reporting a problem. Leaving a field empty will display the default hint for this field only (you can see the default hints below).`,
  ENTER_IMPACT_VALUE: `Enter the impact value for this hint`,
  ENTER_IMPACT_HINT: `Enter the impact hint`,
  ADD_IMPACT_HINT: `Add an impact hint`,
  IMPACT_HINTS_PREVIEW: `Preview`,
  DISPLAY_FULL_IMPACT_HINTS: `Display full hints`,
  SETTINGS_PROBLEMS_MODE: `Default mode`,
  DEFAULT_PROBLEM_MODE: `Default problem reporting mode`,
  INFINITE_PB_BUG: `A lot of problems have been created in the last few seconds.<br> Would you like to keep creating problems ?`,
  INFINITE_PB_BUG_RESUME: `New problems creation was interrupted.<br>Would you like tocreate new problems ?`,
  SIMPLIFIED_MODE: `Simplified mode`,
  ADVANCED_MODE: `Advanced mode`,
  SETTING_SAVED: `Setting saved`,
  THEME_LETTER: `Letter`,
  INDIC_UNIT: `Unit`,
  INDIC_LIB_NAME: `(Library: {name})`,
  MAXIMUM: `Maximum`,
  MAXIMUM_SHORT: `Max`,
  MAXIMUM_SHORT_N: `Max: {n}`,
  MINIMUM: `Minimum`,
  MINIMUM_SHORT: `Min`,
  ADD_INDICATOR: `Add an indicator`,
  ADD_THEME: `Add a theme`,
  ADD_INDICATOR_FROM_LIBRARY: `Add from the library`,
  IMPORT_PUBLIC_INDICATOR: `Import a public indicator`,
  PUBLIC_INDIC_LETTER: `P`,
  INDIC_PUBLIC_FROM_OTHER_TEAM: `This indicator is the one of another team. You can only view its values.`,
  DEFINE_MIN_MAX: `Define a min or max value`,
  DEFINE_VISUAL_TYPE: `Choose the chart type`,
  CHART_TYPE: `Chart type`,
  CHART_LINE: `Line chart`,
  CHART_BAR: `Bar chart`,
  LINE: `Line`,
  BARS: `Bars`,
  PARETO: `Pareto`,
  SPECIFIC_SETTINGS: `Specific settings`,
  SETTINGS_STATIC_VALUES: `Static values`,
  SETTINGS_INCREMENTAL_VALUES: `Incremental values`,
  SETTINGS_INCREMENT_NON_WD: `Increment on non-working days`,
  SETTINGS_PUBLIC: `Public`,
  SETTINGS_PUBLIC_INDIC: `Public indicator`,
  SETTINGS_CALCULATED_INDIC: `Calculated indicator`,
  BETA_CALCULATED_INDIC: `You can now create calculated indicators from other indicators in your dashboard.<br>Feel free to suggest any improvment using the bottom right button.`,
  SETTINGS_INDICATOR_CALC_EXPR: `Calculation expression`,
  SETTINGS_INDICATOR_CALC_SMALL_HINT: `Click on the buttons below the field in order to fill it and create a math expression.`,
  SETTINGS_INDICATOR_CALC_HINT: `@:message.SETTINGS_INDICATOR_CALC_SMALL_HINT <br>The '@:message.MANUAL_INPUT' option allows adding a blank field which you can fill every day whereas the '@:message.INDICATOR_OF_MY_TEAM' button automatically adds values of the selected indicator.<br>\
Example: In order to calculate a defects rate with two indicators (named 'Defects' and 'Production'), Click 1, 0, 0, ×, then '@:message.INDICATOR_OF_MY_TEAM', pick 'Defects', then ÷, then add 'Production'`,
  SETTINGS_INDICATOR_CALC_EXPR_INVALID: `Invalid calculation expression`,
  SETTINGS_CALC_WRONG_PERIOD_UNIT: `All indicators used for the calculation must have the same point period.`,
  SETTINGS_CALC_INDIC_USED_PERIOD_UNIT: `This indicator is currently used in the calculation of '{name}'.<br>@:(message.SETTINGS_CALC_WRONG_PERIOD_UNIT).`,
  SETTINGS_INDIC_CALC_NOT_STATIC: `Static and incremental indicators cannot be calculated indicators.`,
  SETTINGS_INDIC_AVERAGE_AFTER_CALC: `Do the average after the calculation`,
  SETTINGS_INDIC_AVERAGE_AFTER_CALC_HINT: `The values will be divided by the number of working days`,
  INDIC_SPEC_SETTINGS_HELP: `By choosing static values, whenever you enter an indicator value, it will remain on each working day until you've set a new value.<br/><br/>\
  Incremental values work the same way but the values will increase by the number you set next to the checkbox.<br/>By default, the values will increase on working days only, but you can choose to increment the values also on non-working days.<br/><br/>\
  Public indicators can be added to other teams' boards. So ticking this box allows any team of this company to see this indicator's values.<br><br>\
  {gwHint}\
  A calculated indicator's values are computed from a mathematical expression that you can specify after ticking the box.`,
  INDIC_INPUT_INTERVAL_SETTINGS: `Value input frequency`,
  INDIC_INPUT_SETTINGS_HELP: `This is how often you want to set new values for this indicator.<br>If you choose to set values every week, you won't be able to add a different value for each day.<br>Moreover, values will only be displayed when choosing a week point period.`,
  INDIC_DISPLAY_WRONG_PERIOD: `The values of this indicator are {what}. You need to change the current display.`,
  CHANGE_DISPLAY_INDIC_PERIOD: `Display {what} points`,
  WEEKLY: `Weekly`,
  MONTHLY: `Monthly`,
  MONTHLY_FEM: `Monthly`,
  OVER_LONGER_PERIOD: `Over a longer period`,
  CUMULATE: `Cumulate`,
  CALC_AVERAGE: `Average`,
  INDICATORS_SAVED: `Indicators successfully saved`,
  CONFIRM_DELETE_INDICATOR: `Are you sure you want to delete the indicator named {0} ?`,
  CONFIRM_DELETE_THEME: `Are you sure you want to delete the theme named {0} ? All related indicators will be deleted as well`,
  NO_INDICATOR: `No indicators`,
  INDIC_SETTINGS_OBJ_HINT: `(Objective over a {period} period)`,
  INDIC_SETTINGS_CHARTS_DISPLAY: `Charts display`,
  INDIC_SETTINGS_DISPLAY_VALUES: `Display values of each point`,
  INDIC_SETTINGS_DISPLAY_VALUES_HINT: `Display the value of the chart's points as plain text, next to the chart point.`,
  INDIC_SETTINGS_DISPLAY_LABELS: `Display the date of each point`,
  INDIC_SETTINGS_DISPLAY_LABELS_HINT: `Display the date of the point on the x-axis if the point doesn't cumulate the values of multiple days.`,
  INDIC_SETTINGS_NO_LABELS: `None`,
  INDIC_SETTINGS_DISPLAY_LABEL_DATE: `Display the date`,
  INDIC_SETTINGS_DISPLAY_LABEL_CODE: `Display a code (M T W T F)`,
  INDIC_SETTINGS_DISPLAY_LABELS_RADIO_HINT: `By choosing a code, charts will display M, T, W, T, F, when a point is a day ; W1, W2, W3, for weeks ; et Jan., Feb., Mar. for months.`,
  INDIC_SETTINGS_DISPLAY_PROBLEMS_IMPACT: `Display the impact of problems in charts`,
  INDIC_SETTINGS_DISPLAY_PROBLEMS_IMPACT_HINT: `Display the impacts of reported and solved problems to spot the real consequences of problems on the performance indicators. Charts will display a red dot for reported problems and a green dot for solved problems, the size of the dot showing the impact of related problems at this date. Hovering the dots with your mouse or finger will display more details.`,
  INDIC_SETTINGS_THEME_IS_GW: `This indicator theme only contains field tour indicator`,
  INDIC_SETTINGS_IS_GW: `This indicator is a field tour indicator`,
  INDIC_SETTINGS_GW_INDICATOR: `Field tour indicator`,
  INDIC_SETTINGS_REGULAR_INDICATOR: `Regular indicator`,
  INDIC_SETTINGS_REGULAR: `Regular`,
  INDIC_SETTINGS_GW_HINT: `Tick '@:message.INDIC_SETTINGS_GW_INDICATOR' to use this indicator in field tours instead of OK/NOK checks. Moreover, this indicator will not be displayed by default in the indicators page.`,
  INDIC_SETTINGS_GW_NEW_THEME_HINT: `Please choose the new theme of this indicator.`,
  INDIC_SETTINGS_REGULAR_THEMES: `Regular indicator themes`,
  INDIC_SETTINGS_GW_THEMES: `Field tour indicator themes`,
  INDIC_SETTINGS_GW_USAGE_NOT: `This indicator is not used in field tours templates.`,
  INDIC_SETTINGS_GW_USAGE: `This indicator is used {nTimes}.`,
  INDIC_SETTINGS_DELETE_THEME: `Delete theme`,
  INDIC_SETTINGS_DELETE_INDIC: `Delete indicator`,
  INDIC_SETTINGS_DELETE_ORPHAN_ITEMS: `{deleteWhat} and related checklist items`,
  INDIC_SETTINGS_DISPLAY_CALC_COMMENTS: `Display the comments of the indicators used in the calculation`,
  INDIC_SETTINGS_ADAPTATIVE_RANGE: `Scale the y-axis of the chart from its lowest to highest value`,
  MGT_COMPACT_DISPLAY_GW_INDICATORS: `Display field tour indicators in the compact view`,
  GW_INDICATORS_MOVED_TO_SETTINGS: `Field tour indicators can now be edited from the main indicators settings.`,
  IW_TITLE: `Warning messages`,
  IW_NO_MSG_SET: `No warning messages have been set.`,
  IW_SET_A_MSG: `Set a warning message`,
  IW_CUSTOM_MESSAGE: `Type a custom message for this indicator`,
  IW_MSG_PH: `Custom message...`,
  IW_ALLOWED_OVERRUN: `Objective overrun tolerance`,
  IW_N_DAYS: `Lifespan of the message (in days)`,
  IW_CONFIRM_DELETE: `Are you sure you want to delete this warning message ?`,
  IW_YOUVE_SETUP: `You have set up a warning message for this indicator :<br/><br/>{msg}`,
  IA_HINTS: `Assistant's hints`,
  HIDE_HINTS: `Hide assistant's hints`,
  INDIC_INPUT_DEFAULT_DATE: `Indicator input default date`,
  INDIC_INPUT_DEFAULT_HINT: `This is the default date that should be focused when clicking 'Input' button on the detailed indicator page.<br/>You may enter below the number of days between the current date and the selected date by default.`,
  NB_OF_DAYS: `Number of days`,
  SIMPLIFIED: `Simplified`,
  ADVANCED: `Advanced`,
  PICTURES: `Pictures`,
  TAKE_PICTURE: `Take a picture`,
  DONE: `Done`,
  BROWSE_GALLERY: `Browse the gallery`,
  PICK_PICTURE: `Pick a picture`,
  PICK_PICTURE_CAMERA_GALLERY: `By clicking this button, the device will prompt you to choose between the camera and the gallery.`,
  VISUAL: `Visual`,
  OPTIONAL: `Optional`,
  DESCRIPTION: `Description`,
  DESCRIPTION_PH: `Description...`,
  DESCRIPTION_PLACEHOLDER: `Describe the action`,
  DESCRIBE_PROBLEM: `Describe the problem`,
  DEFINE_IMPACT: `Define its impact`,
  LOCATE_PROBLEM: `Locate the problem`,
  LOCATION: `Location`,
  LOCATION_AND_ACTIONS: `Location and actions`,
  CREATED_ON: `Created on`,
  CREATED_BY: `Created by`,
  WHO: `Who`,
  WHAT: `What`,
  WHERE: `Where`,
  WHEN: `When`,
  WHY: `Why`,
  HOW: `How`,
  HOW_MUCH: `How much`,
  TYPE: `Type`,
  TYPES: `Types`,
  KEYWORDS: `Keywords`,
  IMPACT: `Impact`,
  DEADLINE: `Deadline`,
  STATE: `State`,
  LAST_MODIFIED_DATE: `Last modified date`,
  ANALYSIS_STATE_DATE: `Analysis start date`,
  PICTURES_TITLE: `Can you provide a picture of the problem?`,
  WHO_TITLE: `Who is involved?`,
  WHAT_TITLE: `What happened?`,
  WHERE_TITLE: `Where did it happen?`,
  WHEN_TITLE: `When did it happen?`,
  WHY_TITLE: `Why is it a problem?`,
  HOW_TITLE: `How did it happen?`,
  HOW_MUCH_TITLE: `Is it mesurable, quantifiable?`,
  TYPE_TITLE: `What's the type of the problem?`,
  LOCATION_TITLE: `What locations are concerned by this problem?`,
  INDICATORS_TITLE: `Is the problem linked to an indicator?`,
  KEYWORDS_TITLE: `Choose keywords to indentify this problem`,
  IMPACT_TITLE: `Define its impact`,
  DEADLINE_TITLE: `When should it be resolved?`,
  SECURING_ACTIONS_TITLE: `Should you secure the problem with quick actions?`,
  NEXT: `Next`,
  NEX: `Next`,
  PREV: `Prev`,
  PROBLEM_SAVED: `Problem saved`,
  LEADER: `Leader`,
  CATEGORIES: `Categories`,
  UNIT: `Unit`,
  ORIGINAL_DEADLINE: `Original deadline`,
  ORIGINAL_DEADLINE_SHORT: `Initially`,
  ACTION_WAS_POSTPONED_N: `This action was never postponed | This action was postponed once | This action was postponed {n} times`,
  N_POSTPONEMENTS: `No postponements | One postponement | {n} postponements`,
  REASON: `Reason`,
  REASON_PH: `@:message.REASON…`,
  STATE_POSTPONEMENT_REASON: `Please enter a new postponement reason<br>or pick one from the list.`,
  POSTPONEMENT_REASON_NO_PREV: `No previous reason found`,
  POSTPONEMENT_REASON: `Postponement on {date}`,
  POSTPONEMENTS_HISTORY: `Postponements history`,
  NO_POSTPONEMENT_REASON: `The reason for the postponement was not specified.`,
  POSTPONEMENTS_NUMBER: `Number of postponments`,
  POSTPONEMENTS_REASON: `Postponements reason`,
  PICK_A_PB: `Pick a problem`,
  AC_NOT_LINKED_PB: `This action isn't assigned to a problem`,
  AC_NOT_LINKED_CAUSE: `This action isn't assigned to a cause`,
  SECURING_ACTION: `Securing action`,
  SECURING_ACTIONS: `Securing actions`,
  DISPLAY_ONGOING_SECURING_ACTIONS: `Display ongoing securing actions`,
  QUICK_ACTIONS: `Quick actions`,
  LANDSCAPE_DISPLAY: `Display action plans horizontally`,
  SECU_STATE_PENDING: `Pending securing actions`,
  SECU_STATE_ONGOING: `Ongoing securing actions`,
  SECU_STATE_COMPLETED: `All securing actions completed`,
  SAVE_BACK: `Save and go back to the previous page`,
  SAVE_SHEET: `Save and go to the problem sheet`,
  SAVE: `Save`,
  SAVED: `Saved`,
  SETTINGS_SAVED: `Settings saved`,
  CONNECTION_ERROR: `Connection error, please try again later.`,
  INDICATOR_MISSING: `This indicator is missing or has been deleted. You can remove or change this step from the meeting settings.`,
  WRONG_CREDENTIALS: `Please check your credentials again.`,
  LOGIN_SSO_NOT_ENABLED: `Login via SSO isn't enabled for this account.`,
  LOGIN_LAST_ATTEMPT_TOO_CLOSE: `A 2-second delay is required after a failed connection. Please try again.`,
  LOGIN_LOCK_ON_NEXT_FAIL: `Caution: If you enter the wrong password again, the account may be locked and you will not be able to log in.`,
  LOGIN_LOCKED_AFTER_FAILED_LOGIN: `This account has been locked after multiple failed login attempts.`,
  LEAVING_CHANGES_BEHIND: `There are some unsaved changes on this page.`,
  EXIT_WITHOUT_SAVING: `Exit without saving`,
  SAVE_AND_EXIT: `Save and exit`,
  EXIT: `Exit`,
  LEAVE_WARNING: `You are leaving this page. All unsaved data will be lost.`,
  CONTINUE: `Continue`,
  ENTRY_DATE: `Entry date`,
  IN_PROGRESS: `In progress`,
  ENDED: `Ended`,
  REMOVE: `Remove`,
  ARCHIVE: `Archive`,
  PROBLEM_DELETED: `Problem deleted`,
  PROBLEM_ARCHIVED: `Problem archived`,
  PROBLEM_RESTORED: `Problem restored`,
  EXPORT_TO_EXCEL: `Export to excel format`,
  PB_EXPORT_ALL: `Export all the problems as an excel sheet.`,
  ACTION_EXPORT_ALL: `Export all the actions as an excel sheet.`,
  ARCHIVED_THIS_WEEK: `Archived this week?`,
  ARCHIVE_DATE: `Archiving date`,
  WORK_START_DATE: `Work start date`,
  FIRST_ACTION_WORK_DATE: `Date of first action start`,
  ACT_DATE: `Act date`,
  ACTIONS_PROBLEM_WHAT: `'What' of the problem`,
  ACTION_STATE_PENDING: `Pending`,
  ACTION_STATE_ONGOING: `Ongoing`,
  ACTION_STATE_COMPLETED: `Completed`,
  PB_STATES: [
    `Pending analysis`,
    `Ongoing analysis`,
    `Ongoing actions`,
    `Actions completed`,
  ],
  DISPLAY_NUMBER_OF_ACTIONS_PENDING: `Display the number of pending actions in the navigation menu.`,
  ACTIONS_COMPLETION_DATE: `Actions completion date`,
  COMPLETED_ACTIONS: `Completed actions`,
  ONGOING_ACTIONS: `Ongoing actions`,
  PENDING_ACTIONS: `Pending actions`,
  PENDING_PROBLEMS_: `No pending problems|One pending problem|{n} pending problems`,
  COMPLETED_ACTIONS_: `No completed actions|One completed action|{n} completed actions`,
  CAUSE_NOT_VERIFIED: `Cause not verified`,
  CAUSE_VERIFIED: `Cause verified`,
  CAUSE_VERIFIED_REAL: `Valid cause`,
  CAUSE_VERIFIED_NOT_REAL: `Invalid cause`,
  ADD_A_CAUSE: `Add a cause`,
  CAUSE_SUGGESTION: `Cause suggestion`,
  ADD_AN_ACTION: `Add an action`,
  ACTION_SUGGESTION: `Action suggestion`,
  ADD_SECURING_ACTION: `Add a securing action`,
  NEW_ACTION: `New action`,
  ADD_A_COMMENT: `Add a comment`,
  CONFIRM_DELETE_COMMENT: `Are you sure you want to delete this comment? (This cannot be undone)`,
  COMMENT_SAVED: `Comment saved`,
  COMMENT_OF: `Comments of "{currentChecklistItemName}"`,
  HOW_ADD_PICTURE: `How would you like to add a picture ?`,
  NO_LEADER: `No leader`,
  AFFECT_TEAM_NO_LEADER: `Team {team} (No leader)`,
  GAIN: `Gain`,
  GAIN_UNIT_DEFAULT: `£`,
  DEFINE_GAIN: `Define a gain`,
  COMMENTS: `Comments`,
  INDICATORS_AND_COMMENTS: `Indicators et comments`,
  CLICK_TO_TYPE: `Click here to type something...`,
  CLICK_TO_CHANGE: `Click here to change...`,
  COMMENT_PLACEHOLDER: `Add comments to the action`,
  ACTION_LEADER_HISTORY: `History of this action's leader`,
  ACTION_CREATED_BY: `Action created by {name}`,
  ACTION_ASSIGNED_TEAMS: `Team '{fromTeamName}' assigned this action to '{toTeamName}'`,
  ACTION_RETURNED_TEAMS: `Team '{toTeamName}' returned this action to '{fromTeamName}'`,
  ACTION_LEADER_CHANGED: `Team '{teamName}' assigned this action to {toUser} ({toTeamName})`,
  RETURN_ACTION: `Return the action`,
  ACTION_RETURNED: `Action returned`,
  ACTION_PENDING: `Pending`,
  EDIT: `Edit`,
  EDIT_PB: `Edit the problem`,
  EDIT_PICTURES: `Edit pictures`,
  PICTURES_UPDATED: `Pictures updated`,
  CAUSE_SELECT: `Select the cause`,
  CAUSE_UNSELECT: `Unselect the cause`,
  CAUSE_DELETE: `Delete`,
  CAUSE_DELETE_CONFIRM: `Are you sure you want to delete this cause ? <br/>All related actions and pictures will also be deleted`,
  LATEST_PROBLEMS: `Latest problems`,
  OTHER_PROBLEMS: `Other problems`,
  SORT_BY_IMPACT: `By impact`,
  SORT_BY_PROBLEM: `By problem`,
  SORT_BY_ENTRY_DATE: `By entry date`,
  SORT_BY_ADD_IN_ACTION_PLAN_DATE: `By date of addition`,
  SORT_BY_DEADLINE: `By deadline`,
  SORT_BY_SHEET_LAST_MODIFIED: `By sheet's last modified date`,
  SORT_BY_TITLE: `By title (A-Z)`,
  SORT_BY_ARCHIVE_DATE: `By archiving date`,
  ALL: `All`,
  ALLS: `All`,
  UNASSIGNED: `Unassigned`,
  UNASSIGNED_FEM: `Unassigned`,
  UNSPECIFIED: `Unspecified`,
  ACTION_PLAN: `Action plan`,
  NEW_ACTION_PLAN: `New action plan`,
  ADD_ACTION_PLAN: `Add action plan`,
  ACTION_PLAN_MAX_ACTIONS: `Maximum number of actions`,
  ACTION_PLAN_DURATION: `Default duration of actions`,
  DURATION: `Duration`,
  DURATION_BEFORE: `before`,
  TWENTY_FOUR_HOURS: `24h`,
  HOURS: `Hours|Hour|Hours`,
  MINUTES: `Minutes | Minute | Minutes`,
  SECONDS: `Seconds | Second | Seconds`,
  DAYS: `Days | Day | Days`,
  WEEKS: `Weeks | Week | Weeks`,
  MONTHS: `Months | Month | Months`,
  N_TIMES: `0 times | 1 time | {nb} times`,
  N_SECONDS: `0 seconds | 1 second | {nb} seconds`,
  N_HOURS: `0 hours | 1 hour | {nb} hours`,
  N_DAYS: `0 days | 1 day | {nb} days`,
  N_WEEKS: `0 weeks | 1 week | {nb} weeks`,
  N_MONTHS: `0 months | 1 month | {nb} months`,
  EDIT_INDIC_VALUES: `Edit indicators values`,
  STOP_EDIT_INDIC_VALUES: `Stop editing`,
  HIDE_SOME_INDICATORS: `Hide some indicators`,
  N_HIDDEN_INDICATORS: `None hidden | 1 hidden indicator | {nb} hidden indicators`,
  HIDE_INDICATORS_HINT: `You may choose to hide one or several indicators. This can be useful especially when you only want to show short or medium-term indicators.`,
  GROUPED_SELECTION: `Grouped selection`,
  SUPPORT_CHECKBOX: `Support plan (Move actions to this plan to assign them to another team)`,
  ACTION_PLANS_SAVED: `Action plans saved`,
  SAVE_ACTION_PLANS: `Save the action plans`,
  DELETE_ACTION_PLAN_CONFIRM: `Are you sure you want to delete this action plan?<br/>This action cannot be undone.<br/><br/>All actions assigned to this plan will be back to 'pending' status`,
  DELETE_ACTION_PLAN: `Delete this action plan`,
  ACTION_PLAN_DELETED: `Action plan deleted`,
  CANT_EDIT_SUPPORT_WITH_ACTIONS: `You cannot edit a support action plan that contains actions managed by another team.`,
  CANT_EDIT_PLAN_TYPE: `You cannot edit the type of a plan if it contains actions.`,
  PLAN_DROP_HELP: `Drag and drop an action here to add it to the plan`,
  ASSIGN_TO_PLAN_CONFIRM: `Do you want to assign '{actionName}' to '{planName}' ?`,
  ASSIGN_ACTION: `Assign action`,
  ASSIGN_TO_PLAN_IS_QUICK: `This is a quick action. As such, it cannot be added to a specific plan.<br>Instead, you can set this action as "in progress" and it will be displayed in the "@:message.QUICK_ACTIONS" or "@:message.SECURING_ACTIONS" column on the actions page.`,
  SET_ACTION_ONGOING: `Set as 'ongoing`,
  ACTION_MAYBE_IN_OTHER_PLAN: `An error occured, this action may already be assigned to another plan.`,
  REFRESHING_AVAILABLE_TEAMS: `Refreshing available teams`,
  CHOOSE_SUPP_TEAM: `Please choose the support team`,
  ACTION_ASSIGNED: `Action assigned`,
  PLAN_FULL: `It appears that this action plan is full. You may assin the action to another plan or remove some actions from this plan.`,
  ONLY_PLAN_OWNER_ASSIGN: `Only the team that owns the plan can assign actions to it`,
  CANT_ASSIGN_SELF: `This action is already assigned to your team.`,
  CONFIRM_ASSIGN_SAME_SUPPORT: `You are attempting to send this action to the team that assigned it to you in the first place.<br/>If you want to return the action, you can do so by clicking on the 'return' button on the action's page.<br/><br/>Do you really want to assign the action to this team ?`,
  PROBLEM_SHEET: `Problem sheet`,
  ACTION_SHEET: `Action sheet`,
  SUPPORT_LETTER: `S`,
  ACTION_FROM_OTHER_TEAM: `This action has been assigned to you from another team.`,
  PROBLEM_FROM_GW: `This problem has been reported during a field tour`,
  CANT_DELETE_BUT_RETURN: `You may not delete it, but you might want to return it.`,
  TEAM_ACTIONS: `This team actions`,
  ACTIONS_RECEIVED: `Actions received`,
  REMOVE_FROM_PLAN: `Remove this action from the action plan (Back to pending)`,
  REMOVE_FROM_PLAN_CONFIRM: `Do you want to put this action back in pending actions ?`,
  REMOVE_ACTION: `Remove this action`,
  ACTION_REMOVED: `Action removed`,
  ACTION_COMPLETED: `Action completed`,
  ACTION_COMPLETED_CONFIRM: `Is this action completed ?`,
  COMPLETE_ACTION: `Complete and archive`,
  RESTORE_ACTION: `Restore action`,
  ALL_A_ACTION_COMPLETED: `Archive all completed actions`,
  ALL_A_ACTION_COMPLETED_CONFIRM: `@:message.ALL_A_ACTION_COMPLETED?`,
  CONFIRM_DELETE_ACTION: `Are you sure you want to delete this action ?<br/>This cannot be undone.`,
  DELETE_ACTION: `Delete this action`,
  ACTION_DELETABLE_ASSIGNED: `This action can only be deleted by the assigned team.`,
  ACTION_DELETED: `Action deleted`,
  ACTION_RESPONSIBILITY_OTHER_TEAM: `Another team is responsible for this action and your team doesn't have access to it.`,
  CONFIRM_DELETE_PB: `Are you sure you want to delete this problem ?<br/>This cannot be undone.`,
  CONFIRM_ARCHIVE_PB: `Are you sure you want to archive this problem ?<br/>You will be able to restore it from the archives page.`,
  DEFAULT_PERIOD: `Default period`,
  ONE_DAY: `1 day`,
  SEVEN_DAYS: `7 days`,
  FOUR_WEEKS: `4 weeks`,
  TWELVE_MONTHS: `12 months`,
  SEVEN_DAYS_SHORT: `7 d.`,
  FOUR_WEEKS_SHORT: `4 w.`,
  TWELVE_MONTHS_SHORT: `12 m.`,
  PERIOD: `Period`,
  LOADING: `Loading`,
  LOADING_DOTS: `Loading...`,
  BACK: `Back`,
  INPUT: `Input`,
  DISPLAY: `Display`,
  DONT_DISPLAY: `Do not display`,
  DISPLAY_NOUN: `Display`,
  DISPLAY_VALUES: `Display values`,
  CUSTOM_DISPLAY: `Custom display`,
  ENTER_A_NUMBER: `Please enter a number`,
  INDIC_VALUE_HINT_SAVED: `This value has been saved`,
  INDIC_VALUE_HINT_NOT_SAVED: `This value has not been saved`,
  INDICATOR_VALUE_SAVED: `Indicator value saved`,
  INDIC_VALUE_BEFORE_COMMENT: `You need to set a value if you want to add a comment.`,
  CONFIRM_DELETE_INDIC_VAL: `Are you sure you want to delete this value ?<br/>The value's comment will also be deleted.`,
  INDICATOR_VALUE_DELETED: `Indicator value deleted`,
  N_VALUES: `0 values|1 value|{nb} values`,
  INDIC_COMMENT_NEED_VALUE: `Please set a value for the indicator before adding a comment.`,
  CANT_EDIT_PUBLIC_INDIC: `You cannot edit this indicator because it belongs to another team`,
  INDICATOR_OBJECTIVE_SAVED: `Indicator objective saved`,
  NO_ACCESS: `Your team doesn't have access to this content`,
  SETTINGS_DISPLAY_CURRENT_INFOS: `Display current informations`,
  CRITICAL_PROBLEMS: `Critical problems`,
  LOWEST_POSSIBLE_IMPACT: `Lowest possible impact of problems in the dashboard`,
  ELAPSED_DAYS_SINCE_REPORT: `Number of days since the report`,
  DEFAULT_DB_INDIC_VIEW: `Indicators default view`,
  N_DB_ACTIONS_LINES: `Number of lines to be displayed for an action`,
  DISPLAY_GAIN: `Display 'gain' field`,
  MEETINGS_ADD_INFO: `Meetings additional information`,
  HIDE_INFO_GW: `Hide information about upcoming field tours`,
  HIDE_INFO_SUGGESTIONS: `Hide suggestions in information page`,
  MEETINGS_PLANNINGS: `Plannings of the meetings`,
  PLANNINGS: `Plannings`,
  PLANNING: `Planning`,
  ADD_PLANNING: `Add a planning`,
  DELETE_PLANNING_CONFIRM: `Are you sure you want to delete this planning ?`,
  PLANNINGS_SAVED: `Plannings saved`,
  PLANNING_DELETED: `Planning deleted`,
  NEW_MEETING: `New meeting`,
  MEETING_NAME: `Meeting name`,
  MEETING_ROLES: `Roles`,
  MEETING_NO_ROLES: `Roles have not yet been assigned for this meeting`,
  REPEATABILITY: `Repeatability`,
  EVERY_DAY: `Every day`,
  EVERY_WEEK: `Every week`,
  EVERY_MONTH: `Every month`,
  APPLY_TIME_PLANNING: `Apply to other days`,
  ONCE: `Once`,
  DAY: `Day`,
  DAY_OF_MONTH: `Day of month`,
  MONDAY: `Monday`,
  TUESDAY: `Tuesday`,
  WEDNESDAY: `Wednesday`,
  THURSDAY: `Thursday`,
  FRIDAY: `Friday`,
  SATURDAY: `Saturday`,
  SUNDAY: `Sunday`,
  DATE_SWITCHER_DISABLED: `You can only use these dates to change the chart scope. When editing indicators, use the arrows next to any indicator field.`,
  STEP: `Step`,
  STEPS: `Steps`,
  ADD_STEP: `Add a step`,
  STEP_NB: `Step number {stepNumber}`,
  STEP_MIN_DURATION: `Minimum: {stepDuration}`,
  SEE_PAGE: `See page`,
  MGT_INDICATORS: `Management indicators`,
  STATS_FROM_MGT: `Stats from management`,
  SAFETY_SECTION: `Safety section`,
  LINKS_TO_PAGE: `Leads to page`,
  CHOOSE_SETTINGS: `Choose settings`,
  DETAILED_INDICATOR: `Detailed indicator`,
  INDICATOR_INPUT: `Indicator input`,
  MEETING_PAGES: `Meeting pages`,
  MAIN_PAGES: `Main pages`,
  MGT_PAGES: `Management pages`,
  MEETING_END: `End`,
  STARTING: `Starting...`,
  END: `End`,
  PARTICIPANTS: `Participants`,
  ADD_PARTICIPANTS: `Add participants`,
  START_MEETING: `Begin the meeting`,
  MEETING_END_CONFIRM: `Is the meeting over ?`,
  MEETING_ENDED: `Meeting ended`,
  MEETING_LEAVE_CONFIRM: `Do you want to leave the meeting ?`,
  MEETING_LEAVE: `Leave the meeting`,
  MEETING_STARTED_JOIN: `A meeting has started. Will you join it ?`,
  JOIN_MEETING: `Join`,
  DONT_JOIN_MEETING: `Don't join`,
  MEETING_OVER: `This meeting is over`,
  MEETING_REMOTELY_CLOSED: `Meeting is over`,
  ERROR_SAME_MEETING: `You are already participating in this meeting`,
  NOTICE_LEAVE_MEETING: `By doing that, you will leave the current meeting.`,
  MT_CURRENT_PAGE: `Jump to the current page`,
  MEMBERS: `Members`,
  FIRST_NAME: `First name`,
  LAST_NAME: `Last name`,
  ID: `ID`,
  USERNAME: `Username`,
  USERS_UPDATED: `Users updated`,
  LOCATION_CLICK_HINT: `Click to pick a location`,
  WORKING_HOURS: `Working hours`,
  DAY_START: `Start of day`,
  DAY_END: `End of day`,
  SEEK_ROOT_CAUSES: `Seek root causes`,
  FIVE_WHYS: `5 Whys`,
  ISHIKAWA: `Ishikawa`,
  SHOW_ALL_ACTIONS: `See all actions for this problem`,
  CAUSE_SAVED: `Cause saved`,
  CONFIRM_DELETE_FW_CAUSE: `Are you sure you want to delete this cause ?<br/>All the 'children' causes will be affected to its parent.<br/><br/>This cannot be undone.`,
  CAUSE_DELETED: `Cause deleted`,
  DISPLAY_IN_SHEET: `Display in problem sheet`,
  DISPLAY_IN_SHEET_SHORT: `Display in sheet`,
  HIDE: `Hide`,
  SELECT_ROOT_CAUSES: `Select the causes to display in the problem sheet`,
  CONFIRM_DELETE_STICKER: `Delete the sticker ? This cannot be undone.`,
  SUGGESTIONS: `Suggestions`,
  SUGGESTION: `Suggestion`,
  ADD_A_SUGGESTION: `Add a suggestion`,
  MAIN_MENU: `Main menu`,
  TEAMS_MANAGEMENT: `Management`,
  CURRENT_INFOS: `Current informations`,
  NEW_INFO: `New information`,
  MANAGER_TEAMS_TITLE: `{manager}'s teams`,
  NO_TEAMS: `No teams`,
  SELECT_CHILDREN_TEAMS: `Select supervised teams`,
  SELECT_CHILDREN_TEAMS_SHORT: `Sel. supervised`,
  SELECT_BY_HIERARCHY: `Select by hierarchy level`,
  SELECT_ALL_LVL: `Level {lvl}`,
  NO_ACCESS_TO_TEAM: `You don't have access to this team`,
  SELECTED_TEAMS: `Selected teams`,
  INFO_RELEASE_DATE: `Release date`,
  INFO_REMOVAL_DATE: `Removal date`,
  CREATION_DATE: `Creation date`,
  RELEASE_INFO: `Release`,
  DEFAULT_DISPLAY: `Default display`,
  INFO_SAVED: `Information saved`,
  NO_TEAMS_SELECTED: `No teams selected`,
  N_TEAMS_SELECTED: `No teams selected|1 team selected|{nb} teams selected`,
  N_TEAMS_SELECTED_NAMES: `@:message.N_TEAMS_SELECTED ({teamNames})`,
  INFO_MESSAGE: `Information message`,
  INFO_DELETE_CONFIRM: `Delete this information ? (this cannot be undone)`,
  INFO_DELETE: `Delete`,
  INFO_DELETED: `Information deleted`,
  INFO_FW: `Forward`,
  INFO_FW_PICK_TEAM: `Pick at least one other team to forward this information.`,
  INFO_UPCOMING_GW: `The field tour "{name}" will take place on the following dates: {dates}`,
  ADDITIONAL_INFO: `Additional information`,
  INFO_RELATED_GW: `Related field tour`,
  INFO_DISABLED_HINT_GW: `This information cannot be modified for it is a summary of a field tour.`,
  INFO_DISABLED_HINT_OTHER_TEAM: `This information cannot be modified because it was created by another team.`,
  RECIPIENTS: `Recipients`,
  NB_REPORTED_PB: `{nb} reported`,
  NB_COMPLETED_PB: `{nb} completed`,
  ONGOING_PROBLEMS: `Ongoing problems`,
  MONTH: `Month`,
  WEEK: `Week`,
  TODAY: `Today`,
  TODAY_SHORT: `Today`,
  YESTERDAY: `Yesterday`,
  TEAMS_ACTIONS: `Teams actions`,
  NB_LATE_ACTIONS: `including {nb} late`,
  QUICK_ACTION: `Quick action`,
  PDCA: `PDCA`,
  PDCA_BEFORE_P: `Pend.`,
  PDCA_PLAN: `Plan`,
  PDCA_DO: `Do`,
  PDCA_CHECK: `Check`,
  PDCA_ACT: `Act`,
  PDCA_ACT_ARCHIVED: `Act (archived)`,
  PDCA_P: `P`,
  PDCA_D: `D`,
  PDCA_C: `C`,
  PDCA_A: `A`,
  PDCA_MUST_BE_IN_PLAN: `Move the action to an action plan to change the step`,
  LATE_ACTIONS: `Current late actions`,
  LATEST_NEWS: `Latest news`,
  FROM_TEAM: `From '{team}' team`,
  FROM_YOUR_TEAM: `From your team`,
  UPCOMING_INFOS: `Upcoming`,
  INFOS_N_MEETING_SUGG: `No meeting suggestions|One meeting suggestion|{n} meeting suggestions`,
  TEAM_INFOS_SHORT: `Received`,
  SENT_INFOS_SHORT: `Sent`,
  OUR_TEAM: `Our team`,
  TEAM_INFOS: `Our informations for this team`,
  SENT_INFOS: `Informations sent by this team`,
  INFO_DISPLAY_FULL_INFO: `Display the whole content of the items`,
  VISUAL_MODE: `Visual`,
  TEMPLATE: `Template`,
  COMPACT: `Compact`,
  CUMUL: `Accum.`,
  OVER_PERIOD_FROM_TO: `Over the period from {start} to {end}`,
  AVERAGE_GAP_TO_THE_GOAL: `Average gaps to objective per team`,
  TEAM_AVERAGE_GAP: `Team '{team}' has a {gap}{percStr} average gap to its objective on the selected period.`,
  TEAM_VALUES_OK_OBJECIVE: `On the selected dates, team '{team}' values fit its objective.`,
  MGT_SELECTED_INDICATORS: `Selected indicators ({n})`,
  N_EMPTY_VALUES: `No empty values|1 empty value|{nb} empty values`,
  N_VALUES_OUTSIDE: `No values outside the objective|1 value outside the objective|{nb} values outside the objective`,
  N_VALUES_COMPLY: `No values comply with the objective|1 value complies with the objective|{nb} values comply with the objective`,
  PICTURES_FROM_PROBLEMS: `Pictures from problems`,
  CURRENT_PICTURES: `Current pictures`,
  FROM_DEVICE: `From device`,
  PICTURES_FROM_SLEAN: `Pictures from Shizen`,
  CLICK_TO_EDIT: `Click to edit`,
  CONFIRM_REMOVE_STEP: `Remove this step ?`,
  CUSTOM_PAGE: `Customizable page`,
  CUSTOM_TEXT_PH: `Custom text...`,
  REPORTED_PB_NUMBER: `Reported problems number`,
  ONGOING_PB_NUMBER: `Ongoing problems number`,
  COMPLETED_PB_NUMBER: `Completed problems number`,
  PROBLEM_DISTRIBUTION_TYPE: `Problems distribution by type`,
  REPORTED_ACTIONS_NUMBER: `Created actions number`,
  ONGOING_ACTIONS_NUMBER: `Ongoing actions number`,
  COMPLETED_ACTIONS_NUMBER: `Completed actions number`,
  ACTIONS_POSTPONED: `Number of action postponements`,
  REPORTED_GW_PB_NUMBER: `Reported problems from field tour`,
  REPORTED_GW_ACTIONS_NUMBER: `Actions created from field tour`,
  PROBLEM_DISTRIBUTION_INDICS: `Problems distribution by indicator`,
  PROBLEM_RECURRENCE_BREAKDOWN: `Problems recurrence breakdown`,
  MEETING_RATING_DISTRIBUTION: `Meetings distribution by rating`,
  PICTURE_SAVED: `Picture saved`,
  MEETING_STARTED_RESUME: `A meeting named '{name}' was started a few moment ago on this device.<br/>Resume now ?`,
  RESUME: `Resume`,
  DISCARD_MEETING: `Discard`,
  IA_HELP: `Need a hand ?`,
  IA_ANALYSIS: `Analyse`,
  IA_ANALYSIS_TEXT: `Do you need an analysis ?`,
  ANALYSING: `Analysing`,
  VALUE: `Value`,
  OBJECTIVE: `Objective`,
  OBJECTIVE_SHORT: `Obj.`,
  MAX_OBJECTIVE: `Max: {objective}`,
  MIN_OBJECTIVE: `Min: {objective}`,
  OUTSIDE_OBJECTIVE: `{out} / {in} values outside objective range.`,
  OUTSIDE_OBJECTIVE_10_DAYS: `{out} values outside objective range in the last 10 days.`,
  WHAT_DO_BACK_OBJECTIVE: `What actions can be quickly implemented to move back towards the objective?`,
  NB_DAYS_IN_A_ROW_OUTSIDE: `{nb} days in a row outside objective range from {fromDate} to {toDate}.`,
  WHY_OUTSIDE_OBJECTIVE: `Why are the values outside objective range ?`,
  IS_OBJECTIVE_RIGHT: `Is objective set correctly ?`,
  IS_OBJECTIVE_AMBITIOUS: `Is it too ambitious ?`,
  NEED_LINKED_PROBLEM: `Are there any critical problems linked to this indicator ?`,
  N_INDIC_ISSUES_FOUND: `I couldn't find issues with these indicators.|I found an issue with one of your indicators.|I found {nb} indicators with issues.`,
  INDIC_ISSUES_CHECK_OUT: `You may want to have a look.`,
  INDIC_LONGEST_STRAIGHT_OUTSIDE: `At least one indicator with {nb} values in a row outside objective range.`,
  NO_PROBLEMS: `No problems`,
  NO_COMPLETED_PROBLEMS: `No completed problems`,
  NO_COMPLETED_ACTIONS: `No completed actions`,
  NO_CRITICAL_PROBLEM: `No critical problems in the last 30 days.`,
  IS_IMPACT_CORRECTLY_SET: `Is the 'impact' field correctly set ?`,
  N_CRITICAL_PROBLEM: `No critical problems in the last 30 days|One critical problem in the last 30 days|{nb} critical problems in the last 30 days`,
  N_CRITICAL_PENDING_PROBLEM: `.|&nbsp;one of which pending.|&nbsp;{n} of which pending.`,
  CRITICAL_PROBLEM_MUST_BE_RESOLVED: `A critical problem must be addressed within 48 hours after the report.`,
  N_ACTIONS: `No actions|One action|{nb} actions`,
  N_PROBLEMS: `No problems|One problem|{nb} problems`,
  N_PROBLEM_MONTHS: `&nbsp;in the last 30 days, {nbPrev} in the 30 days before that.`,
  N_PROBLEM_INCREASE: `Increase : {nb}%.`,
  N_PROBLEM_DECREASE: `Decrease : {nb}%.`,
  N_PROBLEMS_REPORTED: `0 reported problems | One reported problem | {nb} reported problems`,
  N_PROBLEMS_RESOLVED: `0 problems solved | One problem solved | {nb} problems solved`,
  N_RES_REP_PROBLEMS_IMPACT_SUM: `{nProblems} (Impact sum: {impact})`,
  NO_PROBLEMS_SINCE: `The last problem report occured {nDays} days ago.`,
  DAILY_MGT_MEANS_DAILY_PROBLEMS: `When applying a daily management of performance, at least one problem is usually reported per day.`,
  TEACH_PROBLEM_REPORTING: `Problem reports improve the working conditions of the team members.`,
  N_UNASSIGNED_ACTIONS: `{nb} actions are not assigned. An action should have a leader if it's planned.`,
  USER_MORE_THAN_60PERC_ACTIONS: `The user {user} is assigned more than 60% of the actions`,
  ACTIONS_DISTRIBUTION_STLT: `Distribution of actions : {st}% Short-term / {lt}% Long-term`,
  EVERYONE_SHOULD_PARTICIPATE: `Everyone should participate in the daily action plans.`,
  DAILY_MGT_ST_LT: `In the actions daily mangement, most actions should be planned in the short / medium term.`,
  N_LATE_ACTIONS: `No late actions.|One late action.|{nb} late actions.`,
  IA_HAVE_YOU_TALKED_ABOUT_IT: `Have you talked about it recently ?`,
  REPORT_PROBLEM: `Report a problem`,
  PROBLEM_TRUST_INDEX: `Problem trust index: {index}%`,
  PROBLEM_WELL_DESCRIBED: `Good job, the problem is well described.`,
  IA_HOW_PROBLEM_MUST_BE_DESCRIBED: `Problems should be fully described for a better resolution. It is essential that you provide a picture and fill the 'What' and 'Why' fields.`,
  CAUSES_TRUST_INDEX: `Causes trust index: {index}%`,
  CAUSES_ARE_TRUE_CAUSES: `It appears that these are true causes !`,
  IA_WHAT_IS_TRUE_CAUSE: `A cause has a higher trust index when it is well described and it includes a picture.`,
  ACTIONS_TRUST_INDEX: `Actions trust index: {index}%`,
  ACTIONS_WELL_LINKED: `It's all good, the actions are linked to the problem causes.`,
  IA_ACTIONS_SHOULD_BE_LINKED_TO_CAUSES: `If you have determined the root causes for this problem, you should link actions to them to be sure about their relevance.`,
  IMPROVE_PROBLEM_DECRIPTION: `Improve the problem description`,
  PROBLEM_NEEDS_PICTURE: `The best way to describe a problem is by adding a picture. <br/>You are seeing the issue but anyone who will read the description later won't see it. So your understanding of the problem might not be the same as your colleagues.`,
  IDENTIFIER: `Identifier`,
  IA_TEACH_WHAT: `This question is asked for a better description of the problem.<br/><br/>Examples :<br/><em>What is it ?<br/>What is the current state of the situation ?<br/>What are the consequences ?<br/>What are the risks ?</em>`,
  IA_TEACH_WHO: `This question makes everyone understand who is executing or affected by the issue.<br/><br/>Examples :<br/><em>Who is affected ?<br/>Who is describing the problem ?<br/>Who is affected by the consequences of the problem ?<br/>Who will be afffected by the resolution ?</em>`,
  IA_TEACH_WHERE: `This question corresponds to the description of the problem's precise location. The problem may appear at this location for a reason and at another one for another reason.<br/><br/>Examples :<br/><em>Where does it happen ?<br/>What place(s) does the problem involve ?<br/>In which workshop, which device ?</em>`,
  IA_TEACH_WHEN: `This question defines any data related to the time. This shall help you connect problems that have similar time circumstances.<br/><br/>Examples :<br/><em>How long have you had this problem ?<br/>When does it occur ?<br/>When has it been detected ?<br/>Does it happen repeatedly ? If so, how ?<br/>When does it get dangerous ?</em>`,
  IA_TEACH_HOW: `Describes the procedure to reproduce the problem or how it usually happens.<br/><br/>Examples :<br/><em>How does it happen ?<br/>What are the conditions / circumstances for it to happen ?<br/>How should we proceed ?<br/>Are there any methods ?<br/>How to setup the resolution, what procedures ?</em>`,
  IA_TEACH_HOWMUCH: `This is where you quantify anyhting if necessary.<br/><br/>Examples :<br/><em>How much water is flooding the workshop ?<br/>How many defects until the problem's detection ?</em>`,
  IA_TEACH_WHY: `This is the first step of the proper resolution. You may ask 'Why ?' at every step of the questions before.<br/>When the description is complete and precise, you may begin a 'five whys' analysis which will allow you to spot the true cause(s) of the issue.`,
  IA_TEACH_PROBLEM_TYPES: `This will allow you and your team to categorize the problem. Then you will be able to sort the problems properly.`,
  INCREASE_CAUSES_TRUST: `Increase the causes trust`,
  IA_CAUSE_NEEDS_DESC: `Naming or describing the cause is very important in order to validate it. Using words will create a common understanding of why this problem is a consequence of this cause.`,
  IA_CAUSE_NEEDS_PICTURE: `Just as any problem, the picture allows anyone to understand what the text means even if they weren't there when you were describing the cause.<br/>A picture is proof that the cause is real and must be resolved.`,
  ADD_DESCRIPTION: `Add a description`,
  ADD_PICTURE: `Add a picture`,
  PICTURE: `Picture`,
  IA_CAUSE_NEEDS_ANY: `This cause is empty. An empty cause is useless to a problem resolution. You should at least describe or name it.`,
  MEETING_RATING: `Meeting rating`,
  RATE_MEETING: `Rate this meeting`,
  NO_RATING: `No rating`,
  UNACCEPTABLE: `Unacceptable`,
  ACCEPTABLE: `Acceptable`,
  MEETING_ACTIONS: `Meeting actions`,
  MEETING_ACTION_PH: `Action for the next meetings`,
  REDIRECTING_TO_DASHBOARD: `Redirecting to the home page...`,
  RATING_UPDATED: `Rating updated`,
  LOGOUT: `Log out`,
  LOGGING_OUT: `Logging out...`,
  CAMERA_UNAVAILABLE: `This camera doesn't seem to be available`,
  NOT_AUTHORIZED_CAMERA: `Not authorized to use the camera. Please reload the page or edit the authorizations settings.`,
  WAKING_NEO_UP: `Hold on... waking up Neo`,
  ROLES_ASSIGNEMENT: `Roles assignment`,
  ROLE_LEADER: `Facilitator`,
  ROLE_TIME_KEEPER: `Time keeper`,
  ROLE_CARE_TAKER: `Care taker`,
  ROLE_DECISION_LEADER: `Decision leader`,
  ROLE_FOCUS_KEEPER: `Focus keeper`,
  ROLE_LEADER_DEF: `Sets the pace, facilitates work planning.`,
  ROLE_TIME_KEEPER_DEF: `Helps the facilitator to manage time according to the steps of the meeting.`,
  ROLE_CARE_TAKER_DEF: `Observes human interactions, verifies that everyone participates in the meeting.`,
  ROLE_DECISION_LEADER_DEF: `Ensures that decisions are made. <br/>Also takes notes during the meeting on essential topics.`,
  ROLE_FOCUS_KEEPER_DEF: `Reminds the purpose of the meeting and each of its steps. <br/>Helps to focus on the right intention.`,
  ROLE_ASSIGNED: `Role assigned`,
  ROLES_RANDOM: `Random roles`,
  ROLES_REROLL: `Roles will be reset before being reassigned`,
  DETAILS: `Details`,
  USERS: `Users`,
  TEAMS: `Teams`,
  COMPANY_DETAILS: `Company details`,
  COMPANY_NAME: `Company name`,
  COMPANY_ID: `Company ID`,
  CONTACT_EMAIL: `Email`,
  EMAIL: `Email`,
  ACCESS: `Access`,
  USERS_NB: `Number of users`,
  TEAMS_NB: `Number of teams`,
  CHANGE_CONFIG_PASSWORD: `Change admin password`,
  COMPANY_ID_EXAMPLE: `11000`,
  PWD_BETWEEN_8_25: `Password's length must be between 8 and 25 characters`,
  PWD_DONT_MATCH: `Passwords don't match`,
  PWD_EDITED: `Password updated`,
  PWD_ERROR_CHECK: `An error occured, please check the fields`,
  OLD_PASSWORD: `Old password`,
  NEW_PASSWORD: `New password`,
  NEW_PASSWORD_CONFIRM: `Confirm`,
  LOGO_URL: `Logo URL`,
  LOGO_URL_PLACEHOLDER: `Type the logo URL here...`,
  USE_WHITE_BG: `Use white background`,
  LOGO_UPDATED: `Logo updated`,
  CFG_CHARTS_COLOR: `Charts color`,
  CFG_COLOR_BLUE: `Blue`,
  CFG_COLOR_GREEN: `Green`,
  CFG_CHARTS_FILLING: `Charts filling`,
  CFG_CHARTS_FILL_GOOD: `Fill the area under the values that correspond to the objective`,
  CFG_CHARTS_FILL_BAD: `Fill the area under the values that do not correspond to the objective`,
  CFG_CHARTS_COLOR_OPACITY: `Opacity of the chart's fill color`,
  CFG_CHARTS_COLOR_OPACITY_HINT: `Opacity level of the filling colour. The closer the value is to 0, the more transparent the fill will be. The closer the value is to 100, the more opaque the fill will be.`,
  SORT_AZ: `A to Z`,
  SORT_BY_LEVEL: `hierarchy level`,
  SORT_BY_TEAMS: `teams`,
  SORT_BY_TEAMS_AZ: `teams (A to Z)`,
  SORT_BY_CREATION_DATE: `creation date`,
  HIERARCHY_LEVEL: `Hierarchy level`,
  FILTER_BY_TEAM: `Filter by preferred team`,
  TEAM_UPDATED: `Team updated`,
  TEAMS_UPDATED: `Teams updated`,
  USER_UPDATED: `User updated`,
  IMPORT_XLSX: `Import an Excel file`,
  XLSX_FILE_ERROR: `There was an error with your file. Please feel free to ask Neo some advice.`,
  XLSX_FILE_SEEMS_EMPTY: `The file seems empty. Please feel free to ask Neo some advice.`,
  XLSX_KEEP_TEMP_FORMAT: `Please keep the template format as it is. Feel free to ask Neo some advice.`,
  DOWNLOAD_XLSX_TEMPLATE: `(Download template)`,
  TEAM: `Team`,
  USER: `User`,
  NEW_TEAM: `New team`,
  NEW_USER: `New user`,
  NAME: `Name`,
  YOUR_NAME: `Your name`,
  ALREADY_CREATED_TEAMS: `Already created teams`,
  ADDING_USERS: `Adding users...`,
  USERS_ADDED: `Users created`,
  DELETE_SELECTION: `Delete`,
  ASSIGN_SELECTION: `Assign to a team`,
  UNSELECT_TEAM: `Unselect team`,
  SELECT_ALL: `Select all`,
  UNSELECT_ALL: `Unselect all`,
  CONFIRM_DELETE_USERS: `Are you sure you want to delete these users ? <br/>Their assignments may also be removed.`,
  CONFIRM_DELETE_TEAMS: `Are you sure you want to delete these teams ? <br/>All related data will also be removed.<br/><br/>This includes problems and solving data, actions, indicators and values, and all meeting related data.`,
  TEAMS_REMOVED: `Team(s) removed`,
  USERS_REMOVED: `User(s) removed`,
  CONFIG_ALLOW_SENDING_INFO_ANY_TEAM: `Allow teams to send information to any other team`,
  CONFIG_FORCE_ACTION_POSTPMT_REASON: `Force setting a reason when postponing an action`,
  CONFIG_FORCE_ACTION_POSTPMT_REASON_HINT: `Upon changing an action's deadline to a later date, users will be prompted with a message to enter a reason for the postponement. All the postponements reasons will then appear on the action sheet.`,
  CONFIG_INDICATORS: `Config. indicators`,
  CONFIG_DELETE_INDICATORS: `Delete indicators`,
  CONFIG_INDICATOR_CHOICES: `How would you like to proceed ?<br/><br/><em>Using a template allows you to see the indicators of all the teams that share the same template.<br/>You may also copy the settings of another team to save some time. But if that other team doesn't use a template, users won't be able to see an agglomerated view of the indicators values.</em><br/><br/>If you choose to delete the indicators of this team, you will not be able to retrieve any of the values entered by the team.<br/>If these indicators come from a model, teams that use the same model will not be affected.`,
  CONFIG_CURRENT_SCHEME: `Team {team} is using set named '{schemeName}'.`,
  CONFIG_CURRENT_NOSCHEME: `Team {team} isn't using any set.`,
  CONFIG_CURRENT_SCHEME_PLUR: `Teams {teams} are using indicators set named '{schemeName}'.`,
  CONFIG_CURRENT_NOSCHEME_PLUR: `Teams {teams} aren't using any set of indicators.`,
  CONFIG_ENUM_SEP: `, `,
  CONFIG_ENUM_LAST_SEP: ` and `,
  CONFIG_DISPLAY_TEAMLESS_USERS: `Display users with no preferred team`,
  CONFIG_DISPLAY_ADMINS_ONLY: `Display only administrators`,
  CONFIG_CANT_DELETE_SELF: `You cannot delete yourself.`,
  CONFIG_CANT_REMOVE_LAST_ADMIN: `You cannot remove the last administrator of this company.<br>There need to be at least one administrator.`,
  CONFIG_CANT_DELETE_ADMIN_TEAM: `You cannot delete a team if an administrator sets it as a reference team.<br>You may either remove the administrator role of that user or move it to another team.`,
  CONFIG_CHOOSE_TEMPLATE: `Choose template`,
  COPY_SETTINGS_FROM_OTHER_TEAM: `Copy settings`,
  CONFIG_WORKING_DAYS: `Config. working days`,
  CONFIG_ACTION_PLANS: `Assign action plans`,
  CONFIG_PLANS_CHOICES: `Create new action plans for these teams or use existing parameters from another team.`,
  CREATE_NEW_PLANS: `New action plans`,
  CONFIG_ASSIGN_CFG_PAGES: `Assign configurable pages`,
  CONFIG_ASSIGN_MEETINGS: `Assign meetings`,
  CONFIG_INDIC_SCHEMES: `Indicator templates`,
  CONFIG_NO_SCHEMES_FOUND: `No templates found.`,
  CONFIG_TEAMS_DISPLAY_TEAMS: `Display teams that are using this template`,
  CONFIG_TEAMS_USING_TEMPLATE: `These teams are using this template`,
  CONFIG_TEAMS_NOT_USING_TEMPLATE: `These teams are not using this template`,
  CONFIG_TEAMS_NONE_USING_TEMPLATE: `No teams use this template`,
  CONFIG_CREATE_TEMPLATE: `Create new template`,
  CONFIG_SCHEME_NAME: `Name of the template`,
  CONFIG_SCHEME_NAME_PH: `Name of the template...`,
  CONFIG_DELETE_SCHEME: `If you delete this template, teams that use it will no longer be able to use their indicators.`,
  CONFIG_SCHEME_DELETED: `Template deleted.`,
  CONFIG_SCHEME_DEFAULT: `Default view in management page`,
  CONFIG_SCHEME_DEFAULT_HINT: `By ticking this box, this template will be the one selected by default in the indicators management page.`,
  CONFIG_CONFIRM_NO_EMAIL: `If you don't set a valid email for this team, The team's login information will be sent to info@shizen.io.`,
  CONFIG_TEAM_EDITION: `Team edition`,
  CONFIG_TEAM_NAME_HINT: `This name will be used everywhere on Shizen to interact with this team. Choose a unique name in order to prevent mistakes.`,
  CONFIG_TEAM_EMAIL_HINT: `This email address is used for resetting passwords. It is also used as the default user address if the email address is not set for the members of this team.`,
  CONFIG_TEAM_HIERARCHY_LEVEL_HINT: `The hierarchy level is a visual indicator to help administrators identify teams with a color. Teams with a lower hierarchy level won't have access to some data of the teams with a higher hierarchy level.`,
  CONFIG_TEAM_ACCESSES_HINT: `A list of all the users that should be able to access this team's data.`,
  CONFIG_TEAM_REMOTE_IDP_ID: `If groups have been set up in your company IdP to match Shizen teams, this is the ID of the group that matches this team.`,
  CONFIG_REMOTE_IDP_ID: `IdP group ID`,
  CONFIG_COMPANY_INTERNAL_ID: `Internal company identifier`,
  CONFIG_COMPANY_INTERNAL_ID_HINT: `Identifier used internally.`,
  CONFIG_USER_EDITION: `User edition`,
  CONFIG_USER_MUST_HAVE_TEAM: `You must add this user to a team`,
  CONFIG_USERNAME_ALREADY_EXISTS: `This username already exists`,
  CONFIG_EMAIL_ALREADY_IN_USE: `This email address is already in use`,
  CONFIG_EMAIL_INVALID: `This email address doesn't seem to be valid`,
  CONFIG_USERNAME: `Username`,
  CONFIG_PREFERRED_TEAM: `Preferred team`,
  CONFIG_SEND_USERS_NEW_CREDENTIALS: `Send new credentials`,
  CONFIG_SEND_CREDENTIALS_CONFIRM: `Would you like to reset these users' password and send it to their email adress?<br>Please note that when a user's email address isn't valid, the credentials will be sent to its team's email adress instead.`,
  CONFIG_RESET_AND_SEND_CREDENTIALS: `Reset and send credentials`,
  CONFIG_UPDATE_SENDING_USER_EMAIL: `Updating and sending emails to the selected users`,
  CONFIG_USER_NAMES_HINT: `The first and last names of the user will be displayed in the list of users of a team and whenever this user is responsible for a problem solving or an action for example.`,
  CONFIG_USERNAME_HINT: `The username is a way for the user to log into Shizen. He can also log in by using his team ID.`,
  CONFIG_USER_EMAIL_HINT: `The email address is used to reset the user's password if he ever forgets it. Email notifications can also be set up by the user.`,
  CONFIG_USER_TEAM_HINT: `The preferred team is used to determine the team to log in to by default when the user logs in. It also indicates the hierarchy level of the user.`,
  CONFIG_USER_TEAMS_HINT: `The teams you select here are all the teams of which the user is a member. When logged, the user may switch between these team accounts at will.`,
  CONFIG_THIS_USER_TEAM: `This user's team`,
  CONFIG_USER_ACCESSES_HINT: `The user will be managing the teams above. Any person logged in to '{teamName}' (default team of this user) will have a management overview of these teams and will be able to send them information.`,
  CONFIG_HIERARCHY_TREE: `Organisational chart`,
  CONFIG_DISPLAY_HIERARCHY_TREE: `Display the organisational chart`,
  CONFIG_HIERARCHY_TREE_HINT: `This organisational chart is defined from the hierarchy amongst the teams of a company.<br>\
As long as a team isn't supervised by other teams, it will appear at the root of the chart.<br>\
Find out more by changing the '@:message.SUPERVISOR_TEAMS' and the '@:message.SUPERVISED_TEAMS' attributes of the teams. You may also reorganize the teams relationships on the chart below using drag and drop.`,
  CONFIG_GW_DISALLOW_COMPLETED_EDITING: `Disallow editing of completed field tours`,
  SUPERVISOR_TEAMS: `Supervising teams`,
  SUPERVISED_TEAMS: `Supervised teams`,
  SUPERVISOR_TEAMS_HINT: `Management teams. In the organisational chart, '{name}' will be displayed just below the teams selected here. Leave empty to display this team at the root of the chart.`,
  SUPERVISED_TEAMS_HINT: `Opposite behaviour of '@:message.SUPERVISOR_TEAMS'. Select the teams that should be managed by '{name}'`,
  SUPERVISOR_TEAM_ERROR: `'{name}' team cannot be a supervising team. It is already part of the supervised teams, or it is managed by one of the supervised teams.`,
  SUPERVISED_TEAM_ERROR: `'{name}' team cannot be a supervised team. They supervise this team, or manage one of the supervising teams.`,
  SUPERVISOR_TEAM_SELF_ERROR: `The team cannot supervise itself`,
  CONFIG_USER_ROLES: `User rights`,
  CONFIG_USER_ADMIN_ACCESS: `Allow access to the config`,
  CONFIG_USER_ADMIN_ACCESS_HINT: `Ticking this box will allow the user an access to any page in the config (where you are now). <strong>Only an informed user should be granted an access to this section of Shizen !</strong>`,
  CONFIG_USER_PROBLEMS_ACCESS: `Allow create and update problem`,
  CONFIG_USER_PROBLEMS_ACCESS_HINT: `Ticking this box allows the user to be able to create and update problems`,
  CONFIG_USER_SETTINGS_ACCESS: `Allow access to the team settings`,
  CONFIG_USER_SETTINGS_ACCESS_HINT: `Ticking this box allows the user to be able to change the settings of his team.`,
  CONFIG_USER_SSO_ID: `SSO identifier`,
  CONFIG_USER_SSO_ID_HINT: `This field allow you to create a match between the Identity Provider and Shizen users. Refer to @:message.DETAILS > @:message.SETTINGS_SAML for more information.`,
  CONFIG_SSO_ID_ALREADY_IN_USE: `This SSO ID is already in use`,
  CONFIG_ENABLE_ACCOUNT: `Enable accounts`,
  CONFIG_DISABLE_ACCOUNT: `Disable accounts`,
  CONFIG_ENABLE_ACCOUNT_CONFIRM: `Do you want to re-enable these accounts to allow users to log in again ?`,
  CONFIG_DISABLE_ACCOUNT_CONFIRM: `Disabling these accounts will lo these users out of their accounts and prevent any future login attempt.<br>Additionally, these users will not appear in the team accounts anymore.`,
  CONFIG_ACCOUNTS_ENABLED: `Accounts successfully enabled`,
  CONFIG_ACCOUNTS_DISABLED: `Accounts successfully disabled`,
  CONFIG_STARTUP_TEMPLATE: `Use a start-up template`,
  CONFIG_SAML_PASSWORD_PROTECTED: `Use an Authn Context with a 'PasswordProtectedTransport' method`,
  CONFIG_ENABLE_SAML: `Enable SAML authentication (Single Sign On)`,
  CONFIG_FORCE_SAML: `Force SAML authentication`,
  CONFIG_FORCE_SSO_HINT: `By checking this option, classic authentication will no longer be available and will automatically redirect the user to the Identity Provider's login page.`,
  CONFIG_SAML_ENTITY_ID: `Entity ID`,
  CONFIG_SAML_SSO_URL: `Single Sign On URL (SSO URL)`,
  CONFIG_SAML_SLO_URL: `Single Logout URL (SLO URL)`,
  CONFIG_SAML_CERT: `Base 64 certificate`,
  CONFIG_IMPORT_SAML_XML_META: `Import XML metadata file`,
  CONFIG_EXPORT_SAML_XML_META: `Export XML metadata file`,
  CONFIG_IMPORT_SAML_META_HINT: `Your IdP may provide you with a downloadable metadata file in XML format so that you don't need to fillin the fields below.`,
  CONFIG_SAML_META_FILE_WRONG: `The provided file doesn't seem to be compatibl with SAML 2.0 protocol.`,
  CONFIG_COMPANY_SSO_IDP: `Details of the identity provider of your company`,
  CONFIG_SHIZEN_SSO_SP: `Details of Shizen as a Service Provider`,
  CONFIG_SAML_SP_ENTITY: `Service Provider Entity ID`,
  CONFIG_SAML_ACS_URL: `Assertion Consumer Service URL (ACS)`,
  CONFIG_SAML_SLS_URL: `Single Logout Service URL (SLS)`,
  CONFIG_SSO_MATCH_IDP_SHIZEN: `Match IdP users with Shizen users`,
  CONFIG_SSO_MATCH_IDP_SHIZEN_HINT: `In order to authenticate to Shizen, users will have to authenticate on the Identity Provider (IdP) first. The IdP will then redirect the user to Shizen and provide some information which will allow Shizen to authenticate that user. For that, you need to choose which property will be used for the authentication.`,
  CONFIG_SAML_EXAMPLE_HINT: `After the authentication on the IdP, Shizen will search for a user whose {shizenProperty} matches the '{idpProperty}' property of the IdP information.`,
  CONFIG_SSO_MAPPER_IDP_PROP: `IdP property`,
  CONFIG_SSO_MAPPER_SHIZEN_PROP: `Shizen user property`,
  CONFIG_SAML_SP_PROPS: {
    email: `email`,
    username: `username`,
    ssoId: `SSO identifier`,
  },
  CONTACT_SHIZEN_ADMIN: `Contact your Shizen account administrator for more information.`,
  LOGIN_SSO_IDP_FAILED_AUTHENTICATION: `Your identity provider failed to authenticate you.`,
  LOGIN_SSO_MAPPER_WRONG_IDP_PROP: `Data received from your identity provider didn't contain some required information.`,
  LOGIN_SSO_USER_NOT_FOUND: `User authentication was successful but there was no matching user in Shizen users.`,
  LOGIN_SSO_NEW_USER_PROPS_MISSING: `Your account was not found in Shizen and the data received from the identity provider didn't contain some required information.`,
  LOGIN_SSO_NEW_USER_NO_TEAM_MATCH: `Your account was not found in Shizen and the groups of the identity provider didn't match any team in Shizen.`,
  LOGIN_SSO_NEW_USER_CREATION_ERROR: `There was an error during the creation of your account`,
  LOGIN_SSO_SUCCESSFUL: `Login successful, you are now authenticated as @:(fullNameFormat).`,
  BETA_SSO_LOGIN: `Login through SSO is now available, you can try it out once SSO has been setup by your administrator.`,
  CONFIG_TEST_SSO_LOGIN: `Test connection`,
  CONFIG_SETTINGS_OIDC: `OpenID Connect authentication settings (SSO)`,
  CONFIG_ENABLE_OIDC: `Enable OIDC authentication (Single Sign On)`,
  CONFIG_FORCE_OIDC: `Force OIDC authentication`,
  CONFIG_OIDC_CLIENT_ID: `Client ID`,
  CONFIG_OIDC_SERVER_URL: `Root URL of the identity provider`,
  CONFIG_OIDC_SECRET: `Secret key of the identity provider`,
  CONFIG_OIDC_ACS_URL: `Redirect URL`,
  CONFIG_OIDC_SLO_URL: `Logout URL (Optional)`,
  CONFIG_CANT_SSO_BOTH_SAML_OIDC: `OpenID Connect and SAML cannot be enabled at the same time. In order to enable OIDC login, make sure SAML is disabled and vice versa.`,
  CONFIG_SSO_IDP_GROUPS: `Groups`,
  CONFIG_SSO_AUTO_CREATE_USERS: `Create users automatically`,
  CONFIG_SSO_AUTO_CREATE_USERS_HINT: `You can also choose to create users automatically by matching Shizen teams with your IdP groups. In order to do so, you must create one group for each team that needs automatic account creation, then, fill the '@:message.CONFIG_REMOTE_IDP_ID' property in the teams settings.<br>Finally, indicate the name of the properties used by your IdP to provide the necesary information to identify a user on each SSO.`,
  CONFIG_SSO_OIDC_ADD_CLAIM_HINT: `You may need to grant additional claims to Shizen from your Identity Provider, such as 'groups' claim through the ID token.`,
  CONFIG_OIDC_SCOPES_HINT: `Please specify the scopes you need (separate each value with a space).<br>For example, if you need automatic user creation, you probably need a scope to access the user's first name, last name and group.`,
  CONFIG_OIDC_SCOPES: `Scopes`,
  CONFIG_OIDC_SCOPES_PH: `openid profile email`,
  CONFIG_PROBLEMS: `Problems configuration`,
  CONFIG_STARTUP_TEMPLATES: `Start-up templates`,
  CONFIG_SUT_NAME_PH: `Name of the template`,
  CONFIG_SUT_N_SCHEMES: `No indicator templates|1 indicator template|{n} indicator templates`,
  CONFIG_SUT_N_PAGES: `No configurable pages|1 configurable page|{n} configurable pages`,
  CONFIG_SUT_N_PLANNINGS: `No meetings|1 meeting|{n} meetings`,
  CONFIG_SUT_NEW: `New start-up template`,
  CONFIG_SUT_CONFIRM_DELETE: `Are you sure you want to delete this template?`,
  CONFIG_SUT_APPLY_SELECTED: `Apply selected templates`,
  CONFIG_ACTIONS_HINT: `You can use this page to create action plan templates that you may assign to your teams.<br>First create one or several plans here and add them to your teams from the teams configuration, or through start-up templates.`,
  CONFIG_ACTION_PLAN_TEMPLATES: `Action plan templates`,
  CONFIG_ACTION_PLAN_LIST_TEAMS: `Teams using this plan`,
  LOCATIONS: `Locations`,
  ADD_A_LOCATION: `Add a location`,
  DELETE_SUBZONES: `Would you like to delete the sub-locations too ?`,
  SAVE_BEFORE_ASSIGN: `This action is not saved. Save the sheet to assign the action.`,
  PB_NOT_FOUND: `This problem could not be found. It may have been deleted.`,
  PB_GO_BACK: `Go back`,
  NO_CAUSE: `No linked cause`,
  NO_CAUSE_SELECTED: `No cause selected`,
  ACTION_UPDATED: `Action updated`,
  FS_NOT_SUPPORTED: `Fullscreen is not supported on this browser`,
  NOTIFICATIONS: `Notifications`,
  NOTIFICATION: `Notification`,
  NOTIFICATION_TYPE: `Notification type`,
  NOTIFICATION_EMAIL: `Email`,
  NOTIFICATIONS_SEE: `Notifications settings of`,
  NOTIFICATIONS_SETTINGS_INFO: `Here you can define your personal notification settings.<br>You can enable/disable notifications for you or your team, as well as the emails associated with that notification.`,
  NOTIFICATION_COUNT: `No new notifications|One new notification|{count} unread notifications`,
  NOTIF_TYPE_UPCOMING_MEETING: `Upcoming meeting`,
  NOTIF_TYPE_MEETING_STARTED: `Meeting started`,
  NOTIF_TYPE_ACTION_ASSIGNED: `New action assigned to the team`,
  NOTIF_TYPE_ACTION_COMPLETE: `Action completed by another team`,
  NOTIF_TYPE_PROBLEM_RECEIVED: `Problem received`,
  NOTIF_TYPE_GW_STARTED: `Field tour started`,
  NOTIF_TYPE_INFO_RELEASED: `New information`,
  NOTIF_TYPE_PROBLEM_ACCESS_REVOKED: `Problem access revoked`,
  NOTIF_TYPE_ACTION_RETURNED: `Action sent back`,
  NOTIF_TYPE_USER_ACTION_ASSIGNED: `Action assigned`,
  NOTIF_TYPE_USER_ACTION_DEADLINE_OVERDUE: `Action deadline overdue`,
  NOTIF_TYPE_USER_ACTION_DEADLINE_APPROACHING: `Approaching an action's deadline`,
  NOTIF_TYPE_PROBLEM_COMMENT: `Problem comment`,
  NOTIF_TYPE_PROBLEM_UPDATE: `Problem updated`,
  NOTIF_TITLE_UPCOMING_MEETING: `@:message.NOTIF_TYPE_UPCOMING_MEETING : {name}`,
  NOTIF_TITLE_ONGOING_MEETING: `@:message.NOTIF_TYPE_MEETING_STARTED : {name}`,
  NOTIF_TITLE_NEW_SUPPORT_ACTION: `New action : {name}`,
  NOTIF_TITLE_SUPPORT_ACTION_DONE: `Action completed : {name}`,
  NOTIF_TITLE_PROBLEM_RECEIVED: `@:message.NOTIF_TYPE_PROBLEM_RECEIVED : {name}`,
  NOTIF_TITLE_GW_STARTED: `@:message.NOTIF_TYPE_GW_STARTED : {name}`,
  NOTIF_TITLE_INFO_RELEASED: `@:message.NOTIF_TYPE_INFO_RELEASED`,
  NOTIF_TITLE_PB_ACCESS_REVOKED: `@:message.NOTIF_TYPE_PROBLEM_ACCESS_REVOKED : {name}`,
  NOTIF_TITLE_ACTION_RETURNED: `@:message.NOTIF_TYPE_ACTION_RETURNED : {name}`,
  NOTIF_TITLE_USER_ACTION_ASSIGNED: `@:message.NOTIF_TYPE_USER_ACTION_ASSIGNED : {name}`,
  NOTIF_TITLE_USER_ACTION_DEADLINE_OVERDUE: `@:message.NOTIF_TYPE_USER_ACTION_DEADLINE_OVERDUE : {name}`,
  NOTIF_TITLE_USER_ACTION_DEADLINE_APPROACHING: `@:message.NOTIF_TYPE_USER_ACTION_DEADLINE_APPROACHING : {name}`,
  NOTIF_TITLE_PROBLEM_COMMENT: `New comment : {name}`,
  NOTIF_TITLE_PROBLEM_UPDATE: `@:message.NOTIF_TYPE_PROBLEM_UPDATE : {name}`,
  OTHER_CONNECTED_USERS: `Connected users`,
  PB_HELP_HINT: `Share`,
  PB_HELP_SHARE: `You can share this problem with other teams`,
  PB_HELP_NO_TEAM_FOUND: `No teams were found.`,
  PB_HELP_ADD_TEAMS: `Add teams`,
  PB_HELP_TEAMS_NOTIFIED: `Teams have been notified`,
  PB_HELP_REVOKED: `Access has been revoked`,
  PB_HELP_ACCESS_GRANTED: `Another team sent you this problem`,
  PB_NO_ACCESS: `It seems that you do not have access to this problem.`,
  PB_EDITION_ERROR: `The problem could not be edited.<br/>If the issue persists, try to refresh the page.`,
  PB_AUTO_REFRESH: `Auto refresh`,
  PB_REPORT_SAVE_BEFORE_LEAVE: `Do you want to save the problem before leaving ?`,
  PB_BEEN_REPORTED_TODAY: `This problem has been reported in the last 24 hours`,
  YES_LEAVE_SAVE: `Yes <em class="ml10">(Save, then leave)</em>`,
  NO_LEAVE_WITHOUT_SAVING: `No <em class="ml10">(Leave and delete)</em>`,
  CANCEL_NOT_LEAVING: `Cancel <em class="ml10">(Don't leave)</em>`,
  PB_DELETING: `Deleting problem...`,
  ACTION_SAVE_BEFORE_LEAVE: `Do you want to save the action before leaving ?`,
  ACTION_DELETING: `Deleting action...`,
  INFO_SAVE_BEFORE_LEAVE: `Do you want to save the information before leaving ?`,
  CAUSE_EDITION_ERROR: `The cause could not be edited. Another user may have removed it<br/>If the issue persists, try to refresh the page.`,
  NEW_VERSION_RELOAD: `A newer version is available, please refresh this page.`,
  ACCOUNT_LOCKED: `This account is locked, you cannot log in.`,
  REFRESH: `Refresh`,
  LIST: `List`,
  START_NOW: `Start now`,
  CALENDAR: `Calendar`,
  MEETING: `Meeting`,
  MEETING_FL: `M`,
  GW: `Field tour`,
  GW_FL: `FT`,
  GW_RESTRICTED_ACCESS: `Sorry, you do not have access to this page.`,
  GEMBA_WALKS: `Field tours`,
  GW_MENU: `@:message.GEMBA_WALKS`,
  GW_COMPLETE: `Field tours completed`,
  GW_CONFIRM_DELETE: `Are you sure that you want to delete this tour ?<br/>This cannot be undone.`,
  GW_ITEM_DELETED: `Item deleted`,
  GW_BY_MY_TEAM: `By this team`,
  GW_FOR_MY_TEAM: `For this team`,
  GW_TEMPLATES: `Field tours templates`,
  GW_NEW_TEMPLATE: `Create a new template`,
  GW_CREATING_TEMPLATE: `Creating a new template`,
  GW_EDITING_TEMPLATE: `Editing a template`,
  GW_TEAM_NO_TEMPLATES: `This team doesn't have any template.`,
  GW_TEMPLATE_CONFIRM_DELETE: `Are you sure that you want to delete this template ?<br/>This cannot be undone.`,
  GW_DUPLICATION_NAME: `Please enter the name of the new template.`,
  GW_TEMPLATE_DUPLICATED: `Template duplicated`,
  GW_EDIT_START: `Edit before starting`,
  GW_CHECKLISTS: `Checklists`,
  GW_0_STEPS: `0 steps added`,
  GW_TEAM_NO_CHECKLISTS: `This team doesn't have any checklists.`,
  GW_CL_DELETE: `Delete`,
  GW_CL_DELETED: `Checklist deleted`,
  GW_CL_DELETE_ORPHAN: `Delete and delete orphan indicators`,
  GW_CL_CONFIRM_DELETE: `Are you sure that you want to delete this checklist ?<br/>This cannot be undone.`,
  GW_CONFIRM_DELETE_ITEM: `Are you sure that you want to delete this item ?<br/>This cannot be undone.`,
  GW_CL_ITEMS: `Items`,
  GW_CL_ITEMS_COUNT: `No items in this checklist | 1 item in this checklist | {count} items in this checklist`,
  GW_CL_ITEM_NB: `Item n°{nb}`,
  GW_CL_ITEM_TYPE: `Item type`,
  GW_CL_ITEM_TYPE_OKNOK: `Control item (OK / Not OK)`,
  GW_CL_ITEM_TYPE_GW_INDICATOR: `Enter a field tour indicator value`,
  GW_CL_ITEM_TYPE_DMP_INDICATOR: `Enter a team's indicator value`,
  GW_CL_ADD_ITEM: `Add an item`,
  GW_CL_UNTICK_OPTIONS: `Would you like to remove this checklist or modify it?`,
  GW_CL_REMOVE: `Remove from the step`,
  GW_CL_EDIT: `Modify`,
  GW_SAVED: `Saved !`,
  GW_NAME: `Name`,
  GW_NAME_PLACEHOLDER: `Field tour name`,
  GW_OBJECTIVE: `Objective`,
  GW_OBJECTIVE_PLACEHOLDER: `Describe the objective`,
  GW_PARTICIPANTS: `Participants`,
  GW_ZONES: `Zones`,
  GW_STEP: `Step`,
  GW_STEPS: `Steps`,
  GW_STEP_TEAM_HINT: `Adding teams here will allow you to share the tour results with those teams.`,
  GW_GOAL: `Goal`,
  GW_CHECKLIST: `Checklist`,
  GW_CHECKLIST_ITEM: `Checklist item`,
  GW_NEW: `New`,
  GW_OLD: `Old`,
  GW_NEW_COMMENTS: `New comments`,
  GW_ADD_COMMENT: `Add a comment`,
  GW_VALIDATE_STEP: `Validate this step`,
  GW_INVALIDATE_STEP: `Invalidate step`,
  GW_IS_COMPLETE: `completed`,
  GW_TEAM_SUMMARY_INTRO: `Field tour named '{name}' took place on {date}. `,
  GW_TEAM_SUMMARY_CHECKS: `No checks have been made|Out of {nItems} check, <span class="ok-green">{nOk} OK</span> and <span class="nok-red">{nNok} NOK</span>.|Out of {nItems} checks, <span class="ok-green">{nOk} OK</span> and <span class="nok-red">{nNok} NOK</span>.`,
  GW_TEAM_MSG_DISPLAY: `Display the main message`,
  GW_TEAM_MSG_DISPLAY_CUSTOM: `Display a custom message`,
  GW_TEAM_MSG_HINT: `You can select teams to which you need to send a summary of the tour. Additionally, you might want to write a custom message for each team.<br/>Messages sent from this modal will appear in the teams' information page.<br/>If you do not wish to send messages to those teams, you need to unselect the checkboxes (the default 'tick' behaviour can be changed in the settings).`,
  GW_TEAM_MSG_NONE: `There is no audited teams in this field tour. Add audited teams from the tour's template page.`,
  GW_TEAM_SEND: `Send to {teamName}`,
  GW_END_GW: `Finish the tour`,
  GW_TEAM_LINKED_TO_STEP: `Team linked to this step`,
  GW_NO_LINKED_TEAM: `No linked team`,
  GW_NO_TEAM_IN_TEMPLATE: `There's no team defined in the template of this tour.<br/>Don't forget to define a team if you want to retrieve its data.`,
  GW_FETCH_PROBLEMS: `Fetch team's problems`,
  GW_NO_NAME: `No name has been set`,
  GW_FETCH_ACTIONS: `Fetch team's actions`,
  GW_STEP_PREVIOUS: `Step from the previous tour`,
  GW_SUMMARY: `Summary`,
  GW_N_COMMENTS: `No comments|1 comment|{n} comments`,
  GW_N_PROBLEMS: `No problems|1 problem|{n} problems`,
  GW_N_ACTIONS: `No actions|1 action|{n} actions`,
  GW_CONFIRM_DEL_PB: `Are you sure you want to delete this problem ?<br/>All related data (causes, actions, pictures) will also be deleted.`,
  GW_CONFIRM_DEL_ACTION: `Are you sure you want to delete this action ?`,
  GW_SHOW_ALL_PROBLEMS: `All problems`,
  GW_SHOW_PROBLEMS_FOR: `Problems for '{step}'`,
  GW_SHOW_ALL_ACTIONS: `All actions`,
  GW_SHOW_ACTIONS_STEP: `Actions of '{step}'`,
  GW_SHOW_ACTIONS_OF_PB: `Actions of a problem`,
  GW_SHOW_ACTIONS_PB: `Actions for '{pb}'`,
  GW_DISPLAY_COMMENTS: `Display comments`,
  GW_DISPLAY_CHECKLISTS: `Display checklists`,
  GW_SET_ACTION_TEAM: `Set a team for this action`,
  GW_NO_PB_SELECTED: `No problem selected`,
  GW_SYNTHESIS: `Summary`,
  GW_DETAILED: `Detailed`,
  GW_STEPS_PROBLEMS: `| Step problems | Steps problems`,
  GW_STEPS_CL_PROBLEMS: `| Step's checklists problems | Steps' checklists problems`,
  GW_CONFIRM_DELETE_PLANNING: `Are you sure you want to delete this planning ?<br/>This tour will not appear in your schedule anymore.<br/>This cannot be undone.`,
  GW_NO_STEPS: `No steps have been added. Please add at least one step in order to start a field tour.`,
  GW_NO_ACCESS_PLANNING: `You cannot edit the planning of another team.`,
  GW_PLANNING_DELETED: `Planning deleted`,
  GW_NEW_CL: `New checklist`,
  GW_WAS_EDITED_REFRESH: `Something has been modified. Click to refresh.`,
  GW_STATS: `Field tours stats`,
  GW_NOT_APPLICABLE: `Not applicable`,
  GW_OK_ITEMS: `Valid items`,
  GW_NOK_ITEMS: `Invalid items`,
  GW_PICK_LOCATION: `Pick a location`,
  GW_PICK_TEAM: `Pick a team`,
  GW_AUDITED_TEAMS: `Audited teams`,
  GW_PICK_CHECKLIST: `Pick a checklist`,
  GW_TEMPLATES_SHORT: `Templates`,
  GW_PICK_TEMPLATE: `Pick a template`,
  GW_CLICK_TO_SEE_PB: `Click to see the problems`,
  GW_CLICK_TO_HIDE_PB: `Click to hide the problems`,
  GW_OVER: `The field tour is over`,
  GW_GOTO_SUMMARY: `Go to summary`,
  GW_STAY: `Stay here`,
  GW_CANCELLED: `This field tour has been cancelled`,
  GW_PREV_PAGE: `Previous page`,
  GW_PAGES: `Field tour pages`,
  GW_LAST_COMPLETE: `Last field tour completed`,
  GW_TEAM_N_PROBLEMS: `There's no problems there|This team has one problem|This team has {n} problems`,
  GW_TEAM_1_LATE_PROBLEMS: `, and its resolution is overdue.`,
  GW_TEAM_N_LATE_PROBLEMS: `, none of which are late.|, one of which is late.|, {n} of which are late.`,
  GW_TEAM_N_ACTIONS: `No ongoing actions|This team has one action|This team has {n} ongoing actions`,
  GW_TEAM_1_LATE_ACTIONS: `, and its deadline is overdue.`,
  GW_TEAM_N_LATE_ACTIONS: `@:message.GW_TEAM_N_LATE_PROBLEMS`,
  GW_RATE_REVIEW: `Rate and review`,
  GW_PREVIEW_TOUR: `See the tour`,
  GW_SEND_RATING: `Submit the review`,
  GW_PROMPT_RATE_REVIEW: `Would you like to rate and write a review of the field tour ?`,
  GW_MOOD: `Feelings`,
  GW_RELEVANCE: `Relevance`,
  GW_RATE_MOOD: `Rate how you felt during the tour`,
  GW_RATE_RELEVANCE: `Rate the relevance of the tour`,
  GW_RATE_MOOD_QUESTIONS: `How did the tour go ?<br/>Did the exchanges reflect mutual respect?<br/>What is the overall feeling of everyone?`,
  GW_RATE_RELEVANCE_QUESTIONS: `Do you feel that the tour was useful? <br/>When you received feedback, were it clear and constructive? <br/>Did you get help where you needed it?`,
  GW_RATING_NEEDED_COMMENT: `Please leave a comment so that the field tour participants know what needs to be improved`,
  GW_RATING_OPTIONAL_COMMENT: `You may want to leave a comment if you want to share something with the field tour participants`,
  GW_REVIEW_SAVED: `Review saved`,
  GW_REVIEWS: `Reviews and comments`,
  GW_CANCEL_CONFIRM: `Are you sure you want to cancel this field tour ?<br/>All related data will be deleted.<br/><br/>This cannot be undone.`,
  GW_NOT_FOUND: `This field tour could not be found. It may have been deleted or you don't have access to it.`,
  GW_N_ONGOING: `| There is one ongoing field tour. | There are {nb} ongoing field tours.`,
  GW_CANT_SELECT_NO_TEAMS: `You have to select a team`,
  GW_DEFAULT_TICK_TEAMS_TITLE: `Send tour summary to related teams`,
  GW_DEFAULT_TICK_TEAMS_HINT: `Tick the box to automatically select all related teams in the information box at the end of the field tour.`,
  GW_DEFAULT_TICK_TEAMS: `Tick all teams by default`,
  GW_DEFAULT_HIDE_PREVIOUS: `Hide the previous tour panel by default`,
  GW_DEFAULT_HIDE_PREVIOUS_HINT: `If this option is ticked, when starting a field tour, the previous tour content panel will be hidden by default. You will still be able to open it though.`,
  GW_INDICATORS: `Field tour indicators`,
  GW_HIDDEN_DAYS_ARE: `Hidden days`,
  GW_HIDE_WD: `Hide non-working days`,
  GW_NON_WD: `Non-working days`,
  GW_CUMULATED_NON_WD: `@:message.GW_CUMULATED_NON_WD_BEGINNING there aren't any non-working days per week | @:message.GW_CUMULATED_NON_WD_BEGINNING there is 1 non-working day per week | @:message.GW_CUMULATED_NON_WD_BEGINNING there are {nb} non-working days per week`,
  GW_CUMULATED_NON_WD_BEGINNING: `By cumulating all selected teams' working days, `,
  GW_N_NA_ITEMS: `No N/A items|1 N/A item|{nb} N/A items`,
  GW_N_OK_ITEMS: `No OK items|1 OK item|{nb} OK items`,
  GW_N_NOK_ITEMS: `No NOK items|1 NOK item|{nb} NOK items`,
  GW_NOK_ITEMS_PARETO: `Most recurrent NOK (Not OK) items`,
  GW_NOK_ITEMS_PARETO_ZONES: `Zones with most NOK items`,
  GW_NOK_ITEMS_PARETO_TEAMS: `Audited teams with most NOK items`,
  GW_NOK_CHART_MESSAGE: `<b>Warning</b>: Field tours started before October 20 of 2019 will not be counted on this chart.`,
  GW_PLANNING_CHART: `Compliance with field tour schedule`,
  GW_ITEMS_OK_CHART: `Evolution of the percentage of 'OK', 'NOK' and 'Not applicable' over time`,
  GW_PLANNED_BUT_NOT_CARRIEDOUT: `Planned but not carried out`,
  GW_OVERALL_STATS: `Overall stats`,
  GW_NO_PROBLEMS_STEP: `No problems related to the step`,
  GW_STEP_COMMENTS: `Step comments`,
  GW_STEP_NO_CL: `No checklists for this step`,
  GW_NO_ACCESS: `This field tour isn't accessible to your team.`,
  GW_LEAVE_START: `You are about to leave this page. Any changes made to this field tour will not be saved.`,
  GW_CONFIRM_REMOVE_STEP: `Are you sure you want to remove this step ?`,
  GW_NO_STEP_COMMENT: `No comment for this step.`,
  COPY_OF: `Copy of {sth}`,
  PICK_THEME: `Please pick a theme.`,
  ZONE_INCLUSIVE: `Include sub-zones`,
  TYPE_INCLUSIVE: `Include sub-types`,
  JIRA_TRIGGER: `Report a bug`,
  JIRA_TRIGGER_BUGS: `Go to bugs list`,
  JIRA_WHAT_TYPE: `Would you like to submit :`,
  JIRA_TYPE_BUG: `A bug`,
  JIRA_TYPE_IMPROVE: `An improvement`,
  JIRA_DESCRIPTION: `Description`,
  JIRA_DESCRITION_HINT: `Feel free to provide as many details as possible to describe the issue you are experiencing.<br/>For instance, you may want to describe the steps that allowed you to find the bug.`,
  JIRA_ISSUE_REPORTED: `The issue has been reported. Thank you for reaching out, we will be in touch.`,
  JIRA_ISSUE_CREATION_ERROR_DESCRIPTION: `Please enter a description before sending your request.`,
  JIRA_HOW_ADD_ATTACHMENT: `How would you like to add an attachment?`,
  JIRA_UPLOAD_ATTACHMENT_SUCCESS: `The file has been successfully added.`,
  JIRA_DELETE_ATTACHMENT_SUCCESS: `The file has been successfully deleted.`,
  H_TEXT_ALIGN: `Horizontal text alignment`,
  V_TEXT_ALIGN: `Vertical text alignment`,
  ALIGN_TEXT_WHERE: `Align text`,
  CENTER_TEXT_WHERE: `Center the text`,
  ALIGN_TEXT_TOP: `@:message.ALIGN_TEXT_WHERE to the top`,
  ALIGN_TEXT_BOT: `@:message.ALIGN_TEXT_WHERE to the bottom`,
  ALIGN_TEXT_MID: `@:message.CENTER_TEXT_WHERE vertically`,
  ALIGN_TEXT_LEFT: `@:message.ALIGN_TEXT_WHERE left`,
  ALIGN_TEXT_RIGHT: `@:message.ALIGN_TEXT_WHERE right`,
  ALIGN_TEXT_CENTER: `@:message.CENTER_TEXT_WHERE horizontally`,
  CFG_PAGES: `Configurable pages`,
  PAGE: `Page`,
  WIDGET: `Widget`,
  WIDGETS: `Widgets`,
  CFG_PAGE_CONFIG: `Page config`,
  CFG_PAGE_WIDGET_CONFIG: `Widget config`,
  CFG_PAGE_SPEC_CONFIG: `Specific settings`,
  CUST_PAGES_N_WIDGET: `(No widgets)|(1 widget)|({n} widgets)`,
  CUST_PAGES_NEW: `New configurable page`,
  CFG_PAGES_CREATED: `Page created`,
  CFG_PAGES_DELETED: `Page deleted`,
  CFG_PAGES_CONFIRM_DELETE: `Delete this configurable page ?`,
  CFG_PAGES_HINT_ADD_WIDGET: `Add widgets by dragging items from the right panel.`,
  CFG_PAGE_NAME: `Page name`,
  CFG_PAGE_ADD_MENU: `Add this page to the menu`,
  CFG_PAGE_PREVIEW: `Page preview`,
  CFG_PAGE_ALLOW_TEAM_CREATING_TEMPLATE: `Allow teams to create templates based on their own pages`,
  CFG_PAGE_MAKE_TEMPLATE: `Create a template based on this page`,
  CFG_PAGE_ALREADY_HAS_TEMPLATE: `This page is already linked to a template`,
  CFG_PAGE_COLOR: `Background color`,
  CFG_PAGE_NO_WIDGET_SELECTED: `No widget selected. Click on a widget to edit its config.`,
  CFG_PAGE_DUPLICATE_WIDGET: `Duplicate widget`,
  CFG_PAGE_LIBRARY_INDIC_HINT: `In this field, you may pick an indicator from the indicators library. Upon assigning this page to a team, Shizen will look for the indicator you picked in its indicators and display it in that widget.`,
  FILTER_CFG_PAGES: `Filter configurable pages`,
  CFG_PAGE_LOCK_IMPORT: `Lock this page`,
  CFG_PAGE_LOCK_IMPORT_HINT: `Locking this page will make it impossible for teams to import this page from their settings. Although, the page can be assigned to any team from the config.`,
  CFG_PAGE_SYNCED: `Sync this page`,
  CFG_PAGE_SYNCED_HINT: `When synced, any change made on this page will update the teams pages. Teams won't be allowed to edit existing widgets but will still be able to add new widgets.`,
  CFG_PAGE_CANT_EDIT_TEMPLATE_WIDGET: `Synchronization is activated on this page and this widget is part of the template page. It cannot be modified.`,
  CFG_PAGES_IMPORT_TEMPLATE: `Import a template`,
  CFG_PAGE_SNAPPING: `Widgets snapping`,
  CFG_PAGE_SNAPPING_SPACE: `every`,
  CFG_PAGE_SNAP_EACH_OTHER: `to each other`,
  CFG_PAGE_SNAP_GRID: `to a grid`,
  CFG_W_DESIGN_OPTIONS: `Design options`,
  CFG_W_INNER_MARGIN: `Inner margin`,
  CFG_W_INNER_MARGIN_HINT: `Maximum margin is 10`,
  CFG_W_BORDER: `Border`,
  CFG_W_ROUNED_CORNER: `Rounded corners`,
  WIDGET_DELETE: `Delete this widget`,
  WIDGET_CONFIRM_DELETE: `Delete this widget ?`,
  WIDGET_NAME_TEXT: `Text block`,
  WIDGET_NAME_TEXT_PER_DATE: `Text input per date`,
  WIDGET_NAME_PENDING: `Pending actions list`,
  WIDGET_NAME_BUTTON: `Link to another website`,
  WIDGET_HELP: `Drag this element using your mouse and resize it by dragging the corner.`,
  WIDGET_TEXT_CONTENT: `Content`,
  WIDGET_TEXT_SIZE: `Text size`,
  WIDGET_TEXT_FONT_HINT: `The size of the text will be {mult} times the size of Shizen's font.`,
  WIDGET_TEXT_ALLOW_EDIT: `Editable content`,
  WIDGET_TEXT_ALLOW_SCROLL: `Scrollable content`,
  WIDGET_TEXT_ADAPT_FONT_SIZE: `Adapt the font size to the widget's size`,
  WIDGET_PICTS_ONLY_ONE: `Only one image`,
  WIDGET_PICTS_EDITABLE: `Editable pictures outside of edit mode`,
  WIDGET_PICTS_EDITABLE_HINT: `By checking this option, PDF files will not be interactive anymore.`,
  IMAGES: `Images`,
  IMAGES_AND_DOCS: `Images and documents`,
  WIDGET_SHOW_ICON: `Display website icon`,
  WIDGET_PLANS_OF_CURRENT_TEAM: `Your plans`,
  WIDGET_NO_PLANS_SELECTED: `No action plans selected`,
  WIDGET_INDIC_CUULATED: `Cumulated indicator`,
  WIDGET_INDIC_DISPLAY_RANGE: `Display the range selector`,
  WIDGET_INDIC_GAP_DAYS: `Shift (in days)`,
  WIDGET_INDIC_HINT_ONEDAY: `Today, this indicator would display the value of {day}`,
  WIDGET_INDIC_HINT_RANGE: `Today, this indicator would display values from {start} to {end}`,
  WIDGET_INDIC_NO_SELECTED: `No indicator selected`,
  WIDGET_INDICS_OF_CURRENT_TEAM: `Your indicators`,
  WIDGET_DETAILED_DETAILS: `Display details`,
  WIDGET_DETAILED_ANALYSIS: `Display analysis`,
  WIDGET_DETAILED_PB_ACTIONS: `Display problems and actions`,
  WIDGET_PB_LIST: `Problems list`,
  WIDGET_PB_SORT: `Sorting options`,
  WIDGET_NAME_VIEWER: `Viewer (PDF, video)`,
  WIDGET_VIEWER_WHAT: `Display`,
  WIDGET_VIEWER_PDF: `PDF file`,
  WIDGET_VIEWER_VIDEO: `Video`,
  WIDGET_VIEWER_ADDRESS: `URL address`,
  WIDGET_VIEWER_HTTPS: `https://`,
  WIDGET_VIEWER_LOADING: `Loading external content...`,
  WIDGET_VIEWER_NOT_VALID: `The URL link doesn't seem to be valid. We support URLs from YouTube, dailymotion and Vimeo.`,
  WIDGET_VIEWER_MISSING_ADDRESS: `Please add the URL adress.`,
  WIDGET_VIEWER_UPLOAD_PDF: `Upload from device`,
  WIDGET_NAME_WHEEL: `Indicators month view`,
  WIDGET_WHEEL_NO_THEME: `No theme selected`,
  WIDGET_WHEEL_HIDE_CONTROLS: `Hide the navigation controls`,
  WIDGET_WHEEL_HIDE_INFO: `Hide the additional information`,
  WIDGET_NAME_PAGES_SLIDESHOW: `Pages slideshow`,
  SLIDESHOW_CONTROLS: `Display navigation arrows`,
  SLIDESHOW_AUTO_SCROLL: `Automatic scrolling`,
  SLIDESHOW_LIMIT_REACHED: `There can only be a maximum of 2 slideshow widgets.`,
  SLIDESHOW_NESTED_EMBED: `The content cannot be displayed.<br>A slideshow widget cannot embed another slideshow widget.`,
  SLIDESHOW_ALLOW_INTERACTION: `Allow interacting with the content of the widget`,
  WIDGET_NAME_STICKERS: `Sticky notes`,
  WIDGET_TEXT_PER_DATE_PERIOD_HINT: `This field allows you to pick the time unit you want to use in order to move between periods.`,
  WIDGET_PROBLEMS_SHOW_DELETE_BTN: `Display the delete button on problem items`,
  IDC_CHART: `Charts configuration`,
  IDC_AVAILABLE: `Available configurations`,
  IDC_NEW: `New configuration`,
  IDC_EDITION: `Config edition`,
  IDC_PRESETS: `Presets`,
  IDC_NAME: `Config name`,
  IDC_POINT_PERIOD: `Period of a point`,
  IDC_SIMPLIFIED_PRESETS_HINT: `The simplified mode allows you to choose from the following presets. By clicking on a preset, the selected configuration will be automatically updated.<br/>However, if you need more specific options, you can switch to advanced mode.`,
  IDC_POINT_PERIOD_HINT: `On the new chart, one point will sum up the values of {period} from the normal chart.`,
  IDC_CHART_PERIOD: `Visible range of the chart`,
  IDC_CHART_PERIOD_HINT: `It will display a range of {period}.`,
  IDC_INCR_CUMUL_VALUES: `Increasing cumulated values`,
  IDC_INCR_CUMUL_VALUES_HINT: `Values will increase from the beginning of each cumulation interval until its end.`,
  IDC_INCREASE_INTERVAL: `Values cumulation interval`,
  IDC_INCREASE_PERIOD_HINT: `Values will increase within intervals of {period}.`,
  IDC_INCR_CUMUL_OBJ: `Increasing cumulated objectives`,
  IDC_INCR_CUMUL_OBJ_HINT: `Objectives will be increasing in the same way as the values.`,
  IDC_USE_FIXED_END_DATE: `Set a fixed end date for the chart`,
  IDC_END_DATE: `End date of the chart`,
  IDC_CURRENT_DATE: `Current date`,
  IDC_CURRENT_DATE_GAP: `Current date with an offset`,
  IDC_FIXED_END_DATE: `Fixed end date of the chart`,
  IDC_END_DATE_HINT: `By using a fixed date for the end of the chart, you will not be able to change the period manually. The values displayed in your chart will always be the same.<br>You may also choose the current date with an offset if you always want to display the previous week/month by default for example.`,
  IDC_PRESET_1: `Increasing values per 1-month period. Static objective.`,
  IDC_PRESET_2: `Increasing values per 1-month period. Objective increasing.`,
  IDC_PRESET_3: `Week indicator (cumulated values over a week).`,
  IDC_PRESET_4: `Past week values.`,
  IDC_PRESET_5: `Past week increasing cumulative values.`,
  IDC_SAVING: `Saving the config ...`,
  IDC_SAVED: `Config saved`,
  IDC_CUSTOM: `Custom configurations`,
  IDC_CONFIG_IS_DEFAULT: `This is a default configuration, you cannot edit it.`,
  IDC_DETAILED_INDIC_HINT: `NOTE: On a detailed indicator page, the chart range is 365 days.`,
  WIDGET_IMAGE_SIZE: `Image size`,
  TITLE: `Title`,
  WIDGET_BUTTON_LINK: `Link`,
  RECURRENCE: `Recurrence`,
  NO_PB_FOUND: `No problems found`,
  COMPARING_NB_OF_TOTAL: `Comparing {nb} of {total}`,
  SIMILAR_PBS: `Related problems`,
  SIMILARITIES_FIELDS: `Similarities in the {fieldsList} {fieldsWord}`,
  FIELDS_SUFFIX: `field | fields`,
  NO_SIMILARITY: `No similarity`,
  RECURRENCE_DUPLICATE: `Duplicate`,
  RECURRENCE_DUPLICATE_SHORT: `Dup.`,
  RECURRENCE_DUPLICATE_HINT: `Tick this box if you think the problems are almost identical and that understanding the first problem should help to solve the second.`,
  RELATED: `Related`,
  RELATED_SHORT: `Rel.`,
  RELATED_HINT: `Tick this box if the problems are related and there may be common causes or actions.`,
  RECURRENCE_N_DUPLICATE: `No duplicate problems | 1 duplicate problem | {nb} duplicate problems`,
  RECURRENCE_N_RELATED: `No related problems | 1 related problem | {nb} related problems`,
  DISPLAY_QUICK_FILTERS: `Display quick filters`,
  QFILTER_MY_TEAM: `My team`,
  QFILTER_OTHER_TEAMS: `Other teams`,
  QFILTER_RESOLVED: `Resolved`,
  QFILTER_NOT_RESOLVED: `Not resolved`,
  QFILTER_ARCHIVED: `Archived`,
  QFILTER_NOT_ARCHIVED: `Not archived`,
  SIMILARITY_PERC_NEO: `Neo found a {perc}% similarity between the two problems`,
  PB_DUPLICATE_MERGE_CONFIRM: `Both problems are identical to different problems. Do you want to merge the recurrence data so that all these problems will be considered identical ?`,
  PB_DUPLICATE_MERGE: `Merge`,
  SCREEN_SAVER: `Screensaver`,
  ENABLE_SCREEN_SAVER: `Enable screensaver`,
  SCREEN_SAVER_TIMEOUT: `Inactivity period before starting the screensaver`,
  KEEP_SCREEN_SAVER_PAGE: `Stay at the last screen saver page`,
  PAGES: `Pages`,
  ADD_PAGE: `Add a page`,
  SOCKET_CONNECTING: `Synchronization is being set up.`,
  SOCKET_READY: `Synchronization is established.`,
  SOCKET_CLOSED: `Synchronization is closed. Click to restart it.<br>If a new tab is opened when you click on this button, you might be prompted to trust an SSL certificate.<br>If so, the synchronisation will only start once you accept the connection.`,
  INDICATORS_LIBRARY: `Indicators library`,
  CONFIG_COLLAPSE_ALL: `Collapse all`,
  CONFIG_EXPAND_ALL: `Expand all`,
  NAME_PH: `Name...`,
  THEME_NAME_PH: `Theme name...`,
  LIBRARY_INDIC_UNCATEGORIZED: `Uncategorized`,
  LIBRARY_INDIC_MERGE: `Merge into...`,
  LIBRARY_INDIC_MOVE: `Move`,
  LIBRARY_INDIC_HINT: `This page displays all the indicators of the company.<br/>You can add any of these indicators to the teams' boards by going to the indicators settings or applying a template. You can see below the number of teams that have been assigned an indicator.<br/><br/>Having a single reference for an indicator used accross several teams, allows managers to see accumulated values on a single chart.<br/>You may also want to create a template in order to have a preset in the cumulated indicators page or to aplly a set of indicators to multiple teams quickly.`,
  LIBRARY_INDIC_MERGE_HINT: `Merging indicators allows you to display a cumulated view of the values of multiple teams. If you have created two indicators to monitor accidents for example, you might want to merge them so that the indicators management page displays the sum of the accidents.<br/>Merging library indicators will not affect teams.`,
  LIBRARY_INDIC_MERGE_SAME: `You cannot merge an indicator with itself.`,
  LIBRARY_INDIC_DELETE_THEME_CONFIRM: `Are you sure you want to delete this category ?<br/>All related indicators will be added to the uncategorized indicators.<br/>Related teams will not be affected.`,
  LIBRARY_INDIC_DELETE_CONFIRM: `Are you sure you want to delete this indicator ?<br/>All indicators that refer to this one will be archived.`,
  LIBRARY_INDIC_USED_BY: `Not in use|Currently used by 1 team|Currently used by {n} teams`,
  LIBRARY_INDIC_USE_AVERAGE: `Calculate the average instead of cumulating the values`,
  LIBRARY_INDIC_AVERAGE_HINT: `Managers might want to display an average when working with percentages for example.<br/>When necessary, tick that box to calculate the average of the teams' indicators.`,
  GW_OVERLAY: `Ongoing field tours window`,
  HIDE_GW_OVERLAY: `Hide ongoing field tours window`,
  RESET_GW_OVERLAY: `Reset ongoing field tours window`,
  NOTICE_GW_OVERLAY_IGNORE: `You are about to ignore all ongoing field tours. New field tours will re-open this window.<br><br>Are you sure you want to ignore them ?<br>You can still re-open this window in the settings.`,
  NAVIGATION_MENU: `Navigation menu`,
  MENU: `Menu`,
  SHORTCUTS: `Shortcuts`,
  ADD_A_LINK: `Add a link`,
  RESET_DEFAULT: `Reset to default`,
  RESET: `Reset`,
  RESET_SUCCESS: `Reset successful`,
  NAVIGATION_RESET_CONFIRM: `Are you sure you want to reset the navigation menu to its default configuration ?`,
  NAVIGATION_CUSTOMIZE: `Customize the navigation bar`,
  NAVIGATION_LOCKED: `This item is locked. It cannot be removed.`,
  NAVIGATION_DISPLAY_NAME: `Display the entire title`,
  FILE_UPLOAD_SUCCESS: `File uploaded | {nb} files uploaded`,
  FILE_UPLOAD_ERROR: `Error while uploading file`,
  FILE_UPLOAD_ERROR_SIZE: `The file exceeded the limit of 20MB`,
  FILE_UPLOAD_ERROR_FORMAT: `This file format is not supported (*.pdf, *.bmp, *.gif, *.jpg, *.png, *.xls, *.xlsx, *.ods, *.doc, *.docx, *.odt, *.ppt, *.odp)`,
  FILE_UPLOAD_ERROR_QUOTA: `Your team has exceeded the 100MB limit in Shizen`,
  FILE_DELETE_CONFIRM: `Are you sure you want to delete this file?<br>If the file is used in an information, a problem or an action, deleting this file will remove it from all the pages where it is used | Are you sure you want to delete these files?<br>If the files are used in an information, a problem or an action, deleting these files will remove them from all the pages where they are used`,
  FILE_DELETE_SUCCESS: `File deleted successfully | {nb} files deleted successfully`,
  FILE_DELETE_ERROR: `Failed to delete file`,
  FILE_DELETE_ERROR_NO_ACCESS: `Your team doesn't have access to this file`,
  FILE_REF_COUNT: `Not used in Shizen | Used once in Shizen | Used {nb} times in Shizen`,
  FILES: `Files`,
  ADD_FILES: `Add files`,
  HOW_ADD_FILES: `How would you like to add files?<br>You may reuse files that you or another member of the company uploaded earlier or upload new files.<br><br>You may also paste an image from your clipboard below.`,
  SEARCH_ON_DATABASE: `Search Shizen`,
  PASTE_HERE: `Use paste here`,
  PASTE_HERE_SHORTCUT: `Ctrl + V`,
  PREVIEW: `Preview`,
  DOWNLOAD: `Download`,
  CONFIRM_DELETE_FILE: `Would you like to delete this file ?`,
  NO_PREVIEW: `No preview available`,
  SCHEDULE_PLANNING_ERROR: `Planning error. It seems that this meeting is no longer available for planning.`,
  INFO_AT_DATE: `Information displayed that day ({nb})`,
  NO_INFO_AT_DATE: `No information displayed that day`,
  ISHI_HINT: `Welcome to the Ishikawa diagram tool. You can use this diagram to list and order all possible causes leading to an effect.<br>Create a new cause by clicking the 'Add cause' button at the bottom of a branch. And create a cause's sub-cause (the cause of another cause) by clicking the '+' button next to it.<br>If you want to move an item from one branch to another, you can drag it and drop it above the name of a branch or another cause.`,
  ISHI_BRANCH_ENVIRONMENT: `Mother nature`,
  ISHI_BRANCH_MATERIALS: `Materials`,
  ISHI_BRANCH_MACHINES: `Machines`,
  ISHI_BRANCH_METHODS: `Methods`,
  ISHI_BRANCH_MEN: `Men`,
  ISHI_BRANCHLESS_CAUSES: `Unsorted causes`,
  ISHI_NO_BRANCHLESS_CAUSES: `No unsorted causes`,
  REMOVE_ANNOUNCEMENT: `Remove announcement`,
  DISP_ALL_ANNOUNCEMENTS: `Display all current Shizen announcements`,
  DISP_ANNOUNCEMENTS_HINT: `If you have closed an announcement unintentionally, you may display it again by clicking the button below.`,
  CURRENT_CLOSED_ANNOUNCEMENTS: `Current announcements closed`,
  SHOW_DETAILS: `Show details`,
  HIDE_DETAILS: `Hide details`,
  VISIBLE_CHART_PERIOD: `Visible charts period`,
  CHART_POINT_PERIOD: `Charts point period`,
  DAILY_INDICATORS: `Daily indicators`,
  DAILY_INDICATORS_OVER_THIRTY_DAYS: `@:message.DAILY_INDICATORS over 30 days`,
  DAILY_INDICATORS_DAY_VALUE: `@:(message.DAILY_INDICATORS): Value of the day`,
  DAILY_INDICATORS_YESTERDAY_VALUE: `@:(message.DAILY_INDICATORS): Yesterday's value`,
  WEEKLY_INDICATORS: `Weekly indicators`,
  MONTHLY_INDICATORS: `Monthly indicators`,
  PERIOD_START_DAY: `Start day of the period`,
  DEFAULT_PRESETS: `Default presets`,
  CUSTOM_PRESETS: `Custom presets`,
  MANAGE_PRESETS: `Manage presets`,
  HISTORY: `History`,
  DELETED_PLACEHOLDER: `[Deleted item]`,
  HISTORY_EMPTY: `No history yet.`,
  HISTORY_THE_TEAM: `'{team}' team {didWhat}`,
  HISTORY_THE_TEAM_AND_USER: `{user} ({team}) {didWhat}`,
  HISTORY_CREATION_PB: `has reported a problem ('{title}')`,
  HISTORY_CREATION_CAUSE: `has created a cause ('{title}')`,
  HISTORY_CREATION_ACTION: `has created an action ('{title}')`,
  HISTORY_DELETION_CAUSE: `has deleted a cause`,
  HISTORY_DELETION_ACTION: `has deleted an action`,
  HISTORY_EDIT_PB: `has changed <b>{field}</b> of the problem`,
  HISTORY_FIELD_PB_LWHAT: `the 'what' field`,
  HISTORY_FIELD_PB_LWHO: `the 'who' field`,
  HISTORY_FIELD_PB_LWHERE: `the 'where' field`,
  HISTORY_FIELD_PB_LWHEN: `the 'when' field`,
  HISTORY_FIELD_PB_LHOW: `the 'how' field`,
  HISTORY_FIELD_PB_LHOWMUCH: `the 'how much' field`,
  HISTORY_FIELD_PB_LWHY: `the 'why' field`,
  HISTORY_FIELD_PB_IMPACT: `the impact`,
  HISTORY_FIELD_PB_TYPES: `the types`,
  HISTORY_FIELD_PB_ZONES: `the locations`,
  HISTORY_FIELD_PB_INDICATORS: `the linked indicators`,
  HISTORY_FIELD_PB_KEYWORDS: `the keywords`,
  HISTORY_FIELD_PB_DEADLINE: `the deadline`,
  HISTORY_FIELD_PB_LEADER: `the leader`,
  HISTORY_FIELD_PB_FILES: `the files`,
  HISTORY_FIELD_PB_CAUSE: {
    TEXT: `the text @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    FILES: `the files @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    CAUSE: `the parent cause @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    ISHIKAWABRANCH: `the Ishikawa branch @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    HIDEINSHEET: `the visibility of the causes`,
    ISVERIFIED: `the verified status @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
    ISREAL: `the real status @:message.HISTORY_FIELD_PB_CAUSE_SUFFIX`,
  },
  HISTORY_FIELD_PB_CAUSE_SUFFIX: `of a cause`,
  HISTORY_FIELD_PB_ACTION: {
    NAME: `@:message.HISTORY_FIELD_ACTION_NAME @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    CAUSE: `@:message.HISTORY_FIELD_ACTION_CAUSE @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    LEADER: `@:message.HISTORY_FIELD_ACTION_LEADER @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    IMPACT: `@:message.HISTORY_FIELD_ACTION_IMPACT @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    PDCA: `@:message.HISTORY_FIELD_ACTION_PDCA @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    GAIN: `@:message.HISTORY_FIELD_ACTION_GAIN @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    GAINUNIT: `@:message.HISTORY_FIELD_ACTION_GAIN @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    DEADLINE: `@:message.HISTORY_FIELD_ACTION_DEADLINE @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    COMMENT: `@:message.HISTORY_FIELD_ACTION_COMMENT @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    FILES: `@:message.HISTORY_FIELD_ACTION_FILES @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    PLAN: `@:message.HISTORY_FIELD_ACTION_PLAN @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    STATE: `@:message.HISTORY_FIELD_ACTION_STATE @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
    PROBLEM: `@:message.HISTORY_FIELD_ACTION_PROBLEM @:message.HISTORY_FIELD_PB_ACTION_SUFFIX`,
  },
  HISTORY_FIELD_PB_ACTION_SUFFIX: `of an action`,
  HISTORY_FIELD_PB_CREATED: `the creation date`,
  HISTORY_EDIT_ACTION: `has changed <b>{field}</b> of the action.`,
  HISTORY_FIELD_ACTION_NAME: `the name`,
  HISTORY_FIELD_ACTION_CAUSE: `the linked cause`,
  HISTORY_FIELD_ACTION_LEADER: `the leader`,
  HISTORY_FIELD_ACTION_IMPACT: `the impact`,
  HISTORY_FIELD_ACTION_PDCA: `the PDCA`,
  HISTORY_FIELD_ACTION_GAIN: `the gain`,
  HISTORY_FIELD_ACTION_GAINUNIT: `@:message.HISTORY_FIELD_ACTION_GAIN`,
  HISTORY_FIELD_ACTION_DEADLINE: `the deadline`,
  HISTORY_FIELD_ACTION_COMMENT: `the comments`,
  HISTORY_FIELD_ACTION_FILES: `the files`,
  HISTORY_FIELD_ACTION_PLAN: `the action plan`,
  HISTORY_FIELD_ACTION_STATE: `the state`,
  HISTORY_FIELD_ACTION_PROBLEM: `the problem`,
  SETTINGS_USER_DATA_USAGE: `Shizen may use the first name, last name, picture and email of its users.<ul><li>Displaying the first name, last name and picture in specific places allow all other users to quickly identify the leader of an action, a problem, or a person of interest in regard to elements, such as field tours for example.</li><li>Providing an email address allows users to receive email notifications about events within Shizen, such as actions sent, problems shared, etc.</li></ul>The data will never be used out of Shizen context, nor communicated to any third party.<br>You may request the anonymization of this data from this page by clicking on the 'Delete' button. A request will then be sent directly to the Shizen administrators who will be able to erase the related data.`,
  ERASE: `Erase`,
  CONFIRM_USER_DATA_REMOVAL_REQUEST: `Clicking the button below will send a request to delete this user's data.<br>The removal or anonymisation procedure must be done by the team leader or the administration services, who will be notified by email.<br>Do you confirm this action?`,
  USER_DATA_REMOVAL_DATE: `This user has requested his/her data removal on {date}`,
  ERASE_USER_DATA: `Erase user data`,
  CONFIRM_ERASE_USER_DATA: `Are you sure that you want to delete this user's data ?\nThe user will still exists, but its first name, last name, email address, and picture will be deleted.`,
  CANCEL_USER_DATA_REMOVAL_REQUEST: `Cancel data removal request`,
  FOR_A_TOTAL_OF: `for a total of {what}`,
  OUT_OF_WHAT: `out of {what}.`,
  MAYBE_LATER: `Maybe later`,
  DONT_ASK_AGAIN: `Don't ask again`,
  DISPLAY_ALL_GROUPS: `Display all groups`,
  VITALITY_HUB: `Vitality Hub`,
  VITALITY: `Vitality`,
  VITALITY_OVERALL: `Overall vitality`,
  VITALITY_CRITERIA: `Vitality criteria`,
  VH_TEAM_NAME: `Team name`,
  VH_TEAMS_VITALITY: `Teams vitality`,
  VH_SCORE: `Score`,
  VH_CRIT_BAD: `to analyse`,
  VH_CRIT_INADEQUATE: `to fix`,
  VH_CRIT_ACCEPTABLE: `to improve`,
  VH_CRIT_GOOD: `to refine`,
  VH_DELTA_INCREASE: `{val} point increase | {val} points increase`,
  VH_DELTA_DECREASE: `{val} point decrease | {val} points decrease`,
  VH_DELTA_NEITHER: `No increase or decrease`,
  VH_HIDE_DETAILS: `Hide details`,
  VH_DISPLAY_DETAILS: `Display details`,
  VH_VITALITY_OVER_LAST_PERIODS: `Vitality over the last 6 periods`,
  VH_CRITERIA_OVER_LAST_PERIODS: `Criteria breakdown over the last 6 periods`,
  VH_DISPLAY_GROUPS: `Groups to display`,
  VH_DISPLAY_CATEGORY: `Categories to display`,
  VH_DISPLAY_CRITERIA_ALL: `All`,
  VH_OPTIONS_FILTERS: `Options and filters`,
  VH_FILTER_BY_CRITICALITY: `Filter by criticality`,
  VH_NO_FILTERED_CRITERIA: `No criteria to display with these filters.`,
  VH_ADD_GROUP: `Add a new team group`,
  VH_NEW_GROUP: `New group`,
  VH_CONFIRM_DELETE_GROUP: `Are you sure you want to delete this group ?`,
  VH_CONFIRM_RESET_GROUPS: `Do you want to delete the last group and reset to default groups ?`,
  VH_RESET_GROUPS: `Delete and reset`,
  VH_DEFAULT_TEAMS_MANAGED: `Teams managed by {name}`,
  VH_CRITICALITY_TABLE_USAGE: `Check/uncheck the four boxes below to display/hide the criteria according to their criticality. To enlarge a cell and learn more about the criteria, click on the cell title.`,
  VH_DISPLAY_QUICK_HELP: `Display the help banner`,
  VH_HIDE_QUICK_HELP: `Hide the help banner`,
  VH_DISPLAY_HELP: `Display the Vitality Hub's full help`,
  VH_TIP_SETUP_GROUPS: `Set up the teams or groups of teams of which you need to see the vitality.`,
  VH_TIP_VITALITY: `To have an overview of which teams are doing well and which ones need help.`,
  VH_TIP_CRITERIA: `And to focus on the criteria that need more of your attention.`,
  VH_TIP_DETAILS: `Then display additional details for each category.`,
  VH_PH_GROUP_NAME: `Group name...`,
  VH_LOADING_WAIT: `Loading is already in progress, please wait...`,
  N_TEAMS: `No teams|1 team|{n} teams`,
  N_USERS: `No users|1 user|{n} users`,
  DISPLAY_CHART: `Display the chart`,
  HIDE_CHART: `Hide the chart`,
  VH_WHAT_TEAMS: `teams`,
  VH_WHAT_PROBLEMS: `problems`,
  VH_WHAT_DMP: `daily data`,
  VH_WHAT_GEMBAWALKS: `field tours`,
  VH_FINALIZING: `Finalizing...`,
  VH_LOADING: `Loading {what}...`,
  VH_WORKING: `Calculating vitality : {what}...`,
  VH_READY: `{capWhat} ready...`,
  VH_ERROR: `Error loading {what}...`,
  VH_POINT_INCREASE: `{val}-point increase`,
  VH_POINT_DECREASE: `{val}-point decrease`,
  VH_DEFAULT_CHART_NAME: `Scores`,
  VH_SHOW_ALL_SENSEI_HINTS: `Display the sensei's tips`,
  VH_SHOW_SENSEI_HINT: `Display the tip`,
  VH_HIDE_SENSEI_HINT: `Hide the tip`,
  VH_WELCOME_TOUR: `Welcome to the Vitality Hub !<br>Would you like me to show you around ?`,
  VH_PB_REL_NUMBER: `Evolution of the number of problems`,
  VH_PB_REL_NUMBER_TEXT: `{val}% new problems compared to the last 5 months ({nProblems})`,
  VH_PB_SOLVED_REL_NUMBER: `Problem solving frequency`,
  VH_PB_SOLVED_REL_NUMBER_TEXT: `{val}% solved problems compared to the last 5 months ({nProblems})`,
  VH_PB_TRUST: `Average problem trust index`,
  VH_PB_TRUST_TEXT: `{val}% problem trust index`,
  VH_PB_CAUSES_IN_COMPLETED: `Causes of problems`,
  VH_PB_CAUSES_IN_COMPLETED_TEXT: `{percVerified}% of completed problems have verified causes ({percAnalysis}% from cause analysis).\n{percLinked}% of problem-solving actions are linked to causes ({percLinkedTrue}% to valid causes)`,
  VH_PB_RECURRENCE: `Problems recurrence`,
  VH_PB_RECURRENCE_TEXT: `{val} occurrences of '{text}'`,
  VH_PB_NO_RECURRENCE_TEXT: `No significant recurrence in these problems`,
  VH_PB_RESOLUTION: `Problem solving`,
  VH_PB_RESOLUTION_TEXT: `In the last three periods, {nReportedPb} and {nResolvedPb}`,
  VH_PB_RESOLUTION_NO_PROBLEMS: `No reported problems in the last three periods`,
  VH_PB_LEAD_TIME: `Resolution lead time`,
  VH_PB_LEAD_TIME_TEXT_INC: `{val}% increase in resolution lead time ({displayTime})`,
  VH_PB_LEAD_TIME_TEXT_DEC: `{val}% decrease in resolution lead time ({displayTime})`,
  VH_PB_TYPE_ZONE: `Problems breakdown per area or type`,
  VH_PB_TYPE_ZONE_TEXT_BOTH: `@:message.VH_PB_TYPE_ZONE_TEXT_ONLY_Z, @:message.VH_PB_TYPE_ZONE_TEXT_ONLY_T`,
  VH_PB_TYPE_ZONE_TEXT_ONLY_Z: `{zonePerc}% of problems were reported in '{zoneText}'`,
  VH_PB_TYPE_ZONE_TEXT_ONLY_T: `{typePerc}% of problems are related to '{typeText}'`,
  VH_PB_LATE: `Late problems`,
  VH_PB_TEXT_NONE_RELATED: `No related problems`,
  VH_PB_LATE_TEXT_NOT_COMPLETED: `{nNotCompletedLate} uncompleted late problem|{nNotCompletedLate} uncompleted late problems`,
  VH_PB_LATE_TEXT_COMPLETED: `{nOnTime} problem completed on time|{nOnTime} problems completed on time`,
  VH_AC_NUMBER: `Evolution of the number of actions`,
  VH_AC_NUMBER_TEXT: `{val}% actions created compared to the last 5 periods ({nAction})`,
  VH_AC_ABS_NUMBER_TEXT: `{val} action created | {val} actions created`,
  VH_AC_LATE: `Late actions`,
  VH_AC_LATE_TEXT_NONE_RELATED: `No related actions`,
  VH_AC_LATE_TEXT_NOT_COMPLETED: `{nNotActedLate} uncompleted late action|{nNotActedLate} uncompleted late actions`,
  VH_AC_LATE_TEXT_COMPLETED: `{nOnTime} / {nTotalActed} actions completed on time`,
  VH_AC_POSTPMT: `Action postponements`,
  VH_AC_POSTPMT_TEXT_NONE_COMPLETED: `No actions completed during this period`,
  VH_AC_POSTPMT_TEXT_ACTIONS: `No postponement among completed actions|{nActions} postponed action {suffix}|{nActions} postponed actions {suffix}`,
  VH_AC_LEAD_TIME: `Action lead time`,
  VH_AC_LEAD_TIME_TEXT_INC: `{val}% increase in lead time ({displayTime})`,
  VH_AC_LEAD_TIME_TEXT_DEC: `{val}% decrease in lead time ({displayTime})`,
  VH_GW_ON_SCHEDULE: `Field tours schedule compliance`,
  VH_GW_ON_SCHEDULE_NONE_PLANNED: `No field tours planned`,
  VH_GW_ON_SCHEDULE_TEXT: `{nCompleted} / {nPlanned} completed field tours`,
  VH_GW_NOK_RECURRENCE: `Recurrence of field tours NOK items`,
  VH_GW_NOK_RECURRENCE_PERCENTAGE: `{perc}% OK items in field tours. {recurrenceInfo}`,
  VH_GW_NOK_RECURRENCE_TEXT: `{val} occurrences of '{text}'`,
  VH_GW_NOK_RECURRENCE_NONE_TEXT: `No recurrence in these field tours`,
  VH_GW_NONE: `No completed field tours`,
  VH_GW_PB_RECURRENCE: `Recurrence of field tours problems`,
  VH_GW_RATINGS: `Rating from audited teams`,
  VH_GW_RATINGS_NONE_TEXT: `Field tours haven't been rated`,
  VH_GW_RATINGS_TEXT: `Ratings on feelings are {mood}/10 and on relevance {relevance}/10`,
  VH_GW_NOK_WITHOUT_PROBLEM: `NOK items that are not associated to a problem`,
  VH_GW_NOK_WITHOUT_PROBLEM_TEXT: `{perc}% of NOK items have an associated problem. ({nWithProblems} / {nTotal})`,
  VH_I_NO_VALUES: `No values`,
  VH_I_EXCEEDING: `Values outside the objective range`,
  VH_I_EXCEEDING_TEXT: `Overall, {nb}/{nValues} exceed the objective`,
  VH_I_RECURRENCE: `Values exceeding objectives recurrence`,
  VH_I_RECURRENCE_TEXT: `{val} values exceeding the objective in '{text}'  ({details})`,
  VH_I_RECURRENCE_NONE_TEXT: `No significant exceedance`,
  VH_I_PB: `Number of problems per indicators`,
  VH_I_PB_TEXT: `{problemsNumber} linked to '{text}'`,
  VH_I_PB_NONE_TEXT: `No problems linked to indicators`,
  VH_I_OUTLIERS: `Outlying indicator values`,
  VH_I_OUTLIERS_NONE_TEXT: `There are no outlying values for any of the indicators`,
  VH_I_OUTLIERS_TEXT: `{perc}% of the indicators have outlying values ({nIndicatorsWithOutliers} / {nIndicators})`,
  VH_M_ON_SCHEDULE: `Meetings schedule compliance`,
  VH_M_ON_SCHEDULE_NONE_PLANNED: `No meetings planned`,
  VH_M_ON_SCHEDULE_TEXT: `{nCompleted} / {nPlanned} completed meetings`,
  VH_M_RATING: `Meeting rating`,
  VH_M_NO_RATINGS: `No ratings found`,
  VH_M_NO_MEETING: `No completed meeting`,
  VH_M_RATING_TEXT: `The average score is {value} ({scoreClosest})`,
  VH_M_DURATION: `Planned meetings duration`,
  VH_M_DURATION_TEXT: `On average, meetings are {gap} different from the planned duration`,
  VH_M_PARTICIPANTS: `Meetings attendance`,
  VH_M_PARTICIPANTS_TEXT: `On average, {score}% of the expected participants attend the meetings`,
  VH_I_PB_WHEN_RED: `Number of problems related to off-target indicators`,
  VH_I_PB_WHEN_RED_TEXT: `{score}% of off-target periods have an associated problem ({nWithProblem} / {nTotal})`,
  VH_I_NO_RED_PERIOD: `Indicators are never off-target`,
  ISSUE_BUGS: `Bugs`,
  ISSUE_BUG: `Bug`,
  ISSUE_IMPROVEMENTS: `Improvements`,
  ISSUE_IMPROVEMENT: `Improvement`,
  ISSUE_NEW_ISSUE: `New`,
  ISSUE_PENDING: `Pending`,
  ISSUE_ON_GOING: `On going`,
  ISSUE_FINISHED: `Finished`,
  ISSUE_REFUSED: `Refused`,
  ISSUE_ISSUE_ID: `Issue ID`,
  ISSUE_CREATION_DATE: `Creation date`,
  AUTHOR: `Author`,
  ISSUE_DISCUSSION: `Discussion`,
  ISSUE_NO_COMMENTS: `Discussion space is empty.`,
  ISSUE_NO_ATTACHMENTS: `No attachments are available.`,
  ISSUE_ATTACHMENTS: `Attachments`,
  FREE_VERSION_RESTRICTED: `This feature is not available on a free version. Feel free to contact us to unlock all features.`,
  GET_FULL_SHIZEN_LINK: `<a class="shizen-upgrade-link" href="https://shizen.io/demo" target="_blank">Get the full version</a>`,
  GET_FULL_SHIZEN: `Get the full version`,
  GW_INDICATORS_HINT: `Field tour indicators allow people that carry out field tours to be more precise when collecting data. Additionnally, data can be compiled and displayed on short and long term graphs to analyze the evolution of field tour monitoring.`,
  DISPLAY_NEO_HINTS: `Display Neo's hints`,
  INDIC_NEO_REPORT_PROBLEM: `The last three values of the indicator exceed the objective.<br>Would you like to report a problem about that ?`,
  DONT_SHOW_AGAIN_TEN_DAYS: `Don't show again for 10 days`,
  COMING_SOON: `Coming soon`,
  N_MEMBERS: `No members | 1 member | {nb} members`,
  CURRENT_TEAM: `Current team`,
  OTHER_TEAMS: `Other teams`,
  ACCOUNT_SWITCHED_TEAM: `This account switched to another team. You should refresh the page but you might want to do it later.<br><br>Be aware that you may encounter authorization issues until you have refreshed the page.`,
  ACCOUNT_SWITCH_REFRESH_NOW: `Refresh now`,
  ACCOUNT_SWITCH_REFRESH_LATER: `Refresh later`,
  MY_ACCOUNT: `My account`,
  MY_ACCOUNT_SHORT: `Account`,
  MY_PROBLEMS: `My problems`,
  MY_ACTIONS: `My actions`,
  MY_SENT_ACTIONS: `My sent actions`,
  MY_ACTIONS_HINT: `List of actions for which you are the leader.`,
  MY_SENT_ACTIONS_HINT: `List of actions that you have created, and that have been sent to other teams.`,
  USER_ACCOUNT: `User account`,
  EMAIL_ADDRESS: `Email address`,
  PHONE_NUMBER: `Phone number`,
  CHANGE_MY_PASSWORD: `Change my password`,
  WELCOME_TO_SHIZEN: `Welcome to Shizen!`,
  DATA_USAGE_SUMMARY: `In order to function correctly, Shizen collects some information about you (first and last names, email address). This data is stored in a secure environment and will never be publicly released or communicated to third parties by Shizen.`,
  DATA_USAGE_MY_ACCOUNT: `You may modify this information at any time from the '@:message.MY_ACCOUNT' area.`,
  DATA_USAGE_NAMES_TITLE: `First and last names`,
  DATA_USAGE_NAMES: `First and last names are used to display the members of a team, the person responsible to carry out an action or a problem solving, a meeting participant, ...`,
  DATA_USAGE_EMAIL_TITLE: `Email address`,
  DATA_USAGE_EMAIL: `Your email address allows you to reset your password. Upcoming features will also allow users to receive emails when their actions or problems are updated.`,
  DATA_USAGE_PICTURE_TITLE: `Picture`,
  DATA_USAGE_PICTURE: `The picture is used for the same purpose as the first and last names.`,
  DEFAULT_HOME_PAGE: `Default home page (replace dashboard page)`,
  FILTER_RADIO_ITEMS: `Filter the items below`,
  SETTINGS_MEETINGS_SAVED_AUTOMATICALLY: `Meetings settings are saved automatically.`,
  FILTER_MEETINGS: `Filter meeting templates`,
  NO_FILTER_SELECTED: `No filter selected`,
  MEETING_N_STEPS: `No steps | 1 step | {n} steps`,
  CONFIG_ADMIN: `Config / Administration`,
  BOLD: `Bold`,
  ITALIC: `Italic`,
  UNDERLINE: `Underline`,
  STRIKETHROUGH: `Strikethrough`,
  HIGHLIGHT: `Highlight`,
  HEADING_1: `Heading 1`,
  HEADING_2: `Heading 2`,
  PARAGRAPH: `Paragraph`,
  BULLET_LIST: `Bullet list`,
  NUMBERED_LIST: `Numbered list`,
  CHECK_LIST: `Check-list`,
  BLOCKQUOTE: `Blockquote`,
  HORIZONTAL_LINE: `Horizontal line`,
  CLEAR_FORMATTING: `Clear formatting`,
  UNDO: `Undo`,
  REDO: `Redo`,
  BULLET_POINT: `•`,
  COMMA: `,`,
  STATS_OVERVIEW_TITLE: `Users statistics`,
  STATS_NODATA: `There is no data available.`,
  STATS_STATUS_ONLINE: `Online`,
  STATS_STATUS_OFFLINE: `Offline`,
  STATS_STATUS_OFFLINE_COMPANY: `No user online`,
  STATS_STATUS_AFK: `Away`,
  STATS_STATUS_AFK_COMPANY: `Last user away`,
  SINCE: `since`,
  OVERVIEW_CREATED_PB: `No problem created | 1 problem created | {n} problems created`,
  OVERVIEW_FINISHED_PB: `No problem finished | 1 problem finished | {n} problems finished`,
  CONNECTIONS: `Connections`,
  OVERVIEW_REFRESH: `Refresh data`,
  OVERVIEW_REFRESH_WARNING: `Please refresh the data to update the information.`,
  LIST_OF_COMPANIES: `List of companies`,
  LIST_OF_TEAMS: `List of teams`,
  LIST_OF_USERS: `List of users`,
  SUMMARY_STATS: `Summary of statistics`,
  COMPANIES: `Companies`,
  CREATED_ACTIONS: `Created`,
  CREATED_PROBLEMS: `Created`,
  FINISHED_ACTIONS: `Finished`,
  FINISHED_PROBLEMS: `Finished`,
  SHORT_DAY: `d`,
  ONLINE: `Online`,
  ABSENT: `Away`,
  OFFLINE: `Offline`,
  COMPANY: `Company`,
  TIME: `Time`,
  AVERAGE_CREATION_TIME: `Average creation time`,
  REPORTED_ON_JIRA: `Reported on Jira`,
  SHIZEN_STATS: `Shizen's statistics`,
  // Charts messages
  CHART_CATEGORY_MARKETING: `Marketing`,
  CHART_CATEGORY_DEVELOPMENT: `Development`,
  CHART_CATEGORY_CUSTOMERSUCCESS: `Customer Success`,
  CHART_CATEGORY_PRODUCTLIFE: `Product Life`,
  CHARTS_CREATED_ACTIONS: `Number of actions created`,
  CHARTS_FINISHED_ACTIONS: `Number of actions finished`,
  CHARTS_ACTIONS_UNIT: `actions`,
  CHARTS_CREATED_PB: `Number of problems created`,
  CHARTS_FINISHED_PB: `Number of problems finished`,
  CHARTS_PB_UNIT: `problems`,
  CHARTS_FINISHED_MEETINGS: `Number of completed meetings`,
  CHARTS_MEETINGS_UNIT: `meetings`,
  CHARTS_TIME_CREATING_ACTION: `Time to create an action`,
  CHARTS_TIME_CREATING_PB: `Time to create a problem`,
  CHARTS_BUGS_REPORTED: `Number of reported bugs`,
  CHARTS_BUGS_UNIT: `bugs`,
  CHARTS_TASKS_REPORTED: `Number of tasks reported`,
  CHARTS_TASKS_UNIT: `tasks`,
  CHARTS_TIME_ONLINE: `Time online`,
  CHARTS_TIME_OFFLINE: `Time offline`,
  CHARTS_CONNECTION_FREQUENCY: `Number of connections`,
  CHARTS_LOGIN_UNIT: `connections`,
  COMPLETED_GW_SEE_PARTICIPANTS: `Participants`,
  COMPLETED_GW_PARTICIPATING_TEAM: `Participating team`,
  COMPLETED_GW_NB_THIS_GW: `Participations in this FT`,
  COMPLETED_GW_NB_ALL_GW: `Total number of FT performed`,
  COMPLETED_GW_EMPTY: `No participants have been defined for this Field Tour.`,
  WAIT_INDICATORS_LOADED: `Please wait until indicators are fully loaded.`,
  ACTIONS_PER_CAUSE_MODAL_TITLE: `Actions of the cause`,
  ADD_ACTION_PER_CAUSE: `Add an action related to this cause`,
  NO_ACTION_PLAN: `No action plan`,
  IMPACT_LOW: `Low`,
  IMPACT_MODERATE: `Moderate`,
  IMPACT_SIGNIFICANT: `Significant`,
  IMPACT_CRITICAL: `Critical`,
  IMPACT_DISPLAY: `{val} - {text}`,
  NO_SELECTION: `No selection`,
  // Rating Modal
  RATINGS: `Ratings`,
  RATE: `Rate`,
  GLOBAL_RATING_TITLE: `What do you think of Shizen?`,
  RATING_TITLE: `We want to hear from you!`,
  GLOBAL_RATING_SUBTITLE_INTRO: `We collect reviews in order to improve Shizen and to know how you feel about it.`,
  GLOBAL_RATING_SUBTITLE: `Would you recommend Shizen to your coworkers, or relatives?`,
  I_DONT_RECOMMEND: `I do not recommmend`,
  RATING_STATUS_0: `Very difficult`,
  RATING_STATUS_1: `Difficult`,
  RATING_STATUS_2: `Normal`,
  RATING_STATUS_3: `Easy`,
  RATING_STATUS_4: `Very easy`,
  RATING_SUCCESS_THANKS: `Thank you for your feedback!`,
  RATING_BUTTON_NEVER_AGAIN: `Never ask me again`,
  RATING_NEVER_AGAIN_MESSAGE: `We will no longer ask for your feedback on this page or feature.`,
  // Rating Modal messages by ID
  RATING_MESSAGE_1: `How easy is it to report a problem?`,
  RATING_MESSAGE_2: `How easy is it to fill in an indicator?`,
  RATING_MESSAGE_3: `How easy is it to create an action?`,
  RATING_MESSAGE_4: `How easy is it to create a meeting?`,
  RATING_MESSAGE_5: `How easy is it to run a meeting?`,
  RATING_MESSAGE_6: `How easy is it to conduct a field tour?`,
  // 7 is the global message defined in the rating-modal component itself
  RATING_MESSAGE_8: `How easy is it to create an information?`,
  RATING_MESSAGE_9: `How easy is it to manage indicators?`,
  RATING_MESSAGE_10: `How easy is it to handle problems?`,
  RATING_MESSAGE_11: `How easy is it to manage actions?`,
  RATING_MESSAGE_12: `How easy is it to create a configurable page?`,
  // Excel exported categories
  RATING_EXPORT_BUTTON: `Export ratings`,
  // Those categories below are generated from RatingController.php and are parsed in the exportRatingsToExcel function in rating-utils.js
  RATING_PROBLEM_CREATION: `Creation of a problem`,
  RATING_INDICATOR_INPUT: `Entering an indicator`,
  RATING_ACTION_CREATION: `Creation of an action`,
  RATING_MEETING_CREATION: `Starting a meeting`,
  RATING_MEETING_LEAD: `Running a meeting`,
  RATING_GEMBA_WALK_LEAD: `Running a GW`,
  RATING_GLOBAL: `Global rating`,
  RATING_INFORMATION_CLARITY: `Creating informations`,
  RATING_INDICATOR_MANAGEMENT: `Managing indicators`,
  RATING_PROBLEM_MANAGEMENT: `Managing problems`,
  RATING_ACTION_MANAGEMENT: `Managing actions`,
  RATING_CONFIGURABLE_PAGE_CREATION: `Creating configurable page`,
  VALUE: `Value`,
  STEP_VALIDATION: `Step validation`,
  LAST_CONNECTION: `Last connection on`,
  FIRST_CONNECTION: `First connection on`,
  CREATED: `Created on`,
  TEAM_NOT_FOUND: `No team found`,
  CANNOT_SAVE_TEAM_PARAMETERS: `Team settings could not be saved`,
  USER_NOT_FOUND: `User not found`,
  NOTHING_TO_UPDATE: `Nothing to update`,
  CONFIG_RESTRICT_SETTING_ACCESS_USERS: `Restrict access to settings`,
  CONFIG_RESTRICT_SETTING_ACCESS_USERS_HINT: `By checking this option, only specially authorized users will be able to change the settings for their teams`,
  CONFIG_RESTRICT_PROBLEM_CREATION_UPDATE: `Restrict problem creation and update`,
  CONFIG_RESTRICT_PROBLEM_CREATION_UPDATE_HINT: `By checking this option, only specially authorized users will be able to create or update a problem`,
  ERROR_UNAUTHORIZE: `Not allowed`,
  EVENT: `Event`,
  EVENTS: `Events`,
  N_EVENTS: `No events | 1 event | {nb} events`,
  SHIZEN_NEW_DESIGN: `A new design for Shizen 🎁`,
  SHIZEN_NEW_DESIGN_VIDEO: `Welcome to the new design of Shizen! Watch this video for a quick tour of the changes within Shizen 😊`,
  GOT_IT: `Got it!`,
  UPCOMING_EVENTS: `Upcoming events`,
  OFFLINE_MODE_ON: `You are in offline mode`,
  OFFLINE_MODE_SYNC: `Get back online`,
  OFFLINE_MODE_SLOW_REQUESTS: `The internet connection is taking a while. Would you like to go offline?`,
  OFFLINE_MODE_TURN_ON: `Offline mode`,
  OFFLINE_MODE_PROMPT_OFF: `Would you like to get back online?`,
  OFFLINE_MODE_PROMPT_OFF_NEED_SYNC: `A short synchronization is required to send some local data online.`,
  OFFLINE_MODE_SYNCING: `Shizen is syncing the following data online. Please wait until the synchronization finishes, or click the cancel button to stay offline.`,
  OFFLINE_MODE_SYNCING_OVER: `Synchronization is over. You can now close this window and keep using Shizen online.`,
};

export default messages;
